import { c as createCommonjsModule, a as _createClass$1, b as _classCallCheck$1, f as _slicedToArray$1, j as _objectSpread2, k as _toConsumableArray } from "./_commonjsHelpers-b0e8727a.js";
import { i as isObject, b as baseGetTag, r as root, a as isObjectLike, S as Symbol$1, f as freeGlobal, c as isSymbol, e as debounce } from "./debounce-c95729f2.js";
import { createStore, applyMiddleware, compose } from "redux";
import FlyToInterpolator from "react-map-gl/dist/esm/utils/transition/viewport-fly-to-interpolator";

var TIMELINE_STEP = 864e5,
    MIN_FRAME_LENGTH_MS = TIMELINE_STEP,
    VESSELS_RADIAL_GRADIENT_STYLE_ZOOM_THRESHOLD = 6,
    VESSELS_BASE_RADIUS = 8,
    VESSELS_HEATMAP_BLUR_FACTOR = .15,
    ACTIVITY_HIGHLIGHT_HUE = 312,
    VESSELS_HEATMAP_DIMMING_ALPHA = .5,
    MAX_SPRITES_PER_LAYER = 2e5,
    VESSEL_CLICK_TOLERANCE_PX = 10,
    CLUSTER_CLICK_ZOOM_INCREMENT = 1,
    MIN_ZOOM_LEVEL = 1,
    MAX_ZOOM_LEVEL = 14,
    ACTIVITY_LAYERS_MAX_ZOOM_LEVEL_TILE_LOADING = 10,
    TILES_LOAD_ZOOM_OFFSET = .5,
    STATIC_LAYERS_CARTO_ENDPOINT = "https://carto.globalfishingwatch.org/user/admin/api/v1/map?config=$MAPCONFIG",
    STATIC_LAYERS_CARTO_TILES_ENDPOINT = "https://carto.globalfishingwatch.org/user/admin/api/v1/map/$LAYERGROUPID/{z}/{x}/{y}.mvt",
    TRACKS_LAYER_IN_FRONT_OF_GROUP = "temporal",
    TILES_URL_NEEDING_AUTHENTICATION = "gateway.api",
    INIT_MODULE = "INIT_MODULE",
    SET_TEMPORAL_EXTENT = "SET_TEMPORAL_EXTENT",
    SET_HIGHLIGHT_TEMPORAL_EXTENT = "SET_HIGHLIGHT_TEMPORAL_EXTENT",
    START_LOADER = "START_LOADER",
    COMPLETE_LOADER = "COMPLETE_LOADER",
    SET_MODULE_CURSOR = "SET_MODULE_CURSOR",
    initModule = function initModule(e) {
  return function (t) {
    t({
      type: INIT_MODULE,
      payload: e
    });
  };
},
    startLoader = function startLoader(e, t, r) {
  var a = new Date().getTime(),
      n = void 0 !== r ? "".concat(r, "_").concat(a) : a;
  return e({
    type: START_LOADER,
    payload: n
  }), void 0 !== t.map.module.onLoadStart && t.map.module.onLoadStart(), r;
},
    completeLoader = function completeLoader(e) {
  return function (t, r) {
    t({
      type: COMPLETE_LOADER,
      payload: e
    });
    var a = r();
    a.map.module.loaders.length || void 0 === a.map.module.onLoadComplete || a.map.module.onLoadComplete();
  };
},
    onViewportChange = function onViewportChange(e) {
  return function (t, r) {
    var a = r(),
        n = a.map.module.onViewportChange;

    if (void 0 !== n) {
      var o = a.map.viewport;
      n({
        interactionState: e,
        zoom: o.viewport.zoom,
        center: [o.viewport.latitude, o.viewport.longitude],
        bounds: o.bounds,
        canZoomIn: o.canZoomIn,
        canZoomOut: o.canZoomOut,
        mouseLatLong: o.mouseLatLong
      });
    }
  };
},
    setTemporalExtent = function setTemporalExtent(e) {
  return {
    type: SET_TEMPORAL_EXTENT,
    payload: e
  };
},
    setHighlightTemporalExtent = function setHighlightTemporalExtent(e) {
  return {
    type: SET_HIGHLIGHT_TEMPORAL_EXTENT,
    payload: e
  };
},
    closePopup = function closePopup() {
  return function (e, t) {
    var r = t();
    void 0 !== r.map.module.onClosePopup && r.map.module.onClosePopup();
  };
},
    setCursor = function setCursor(e) {
  return {
    type: SET_MODULE_CURSOR,
    payload: e
  };
},
    GL_TRANSPARENT = "rgba(0,0,0,0)",
    TRANSITION_TYPE = {
  ZOOM: "ZOOM"
},
    BRUSH_RENDERING_STYLE = {
  NORMAL: 0,
  BULLSEYE: 2
},
    BRUSH_ZOOM_RENDERING_STYLE = {
  RADIAL_GRADIENT: 0,
  CIRCLE: 1
},
    POLYGON_LAYERS_AREA = "POLYGON_LAYERS_AREA",
    CUSTOM_LAYERS_SUBTYPES = {
  geojson: "geojson",
  raster: "raster"
},
    asyncTag = "[object AsyncFunction]",
    funcTag = "[object Function]",
    genTag = "[object GeneratorFunction]",
    proxyTag = "[object Proxy]";

function isFunction(e) {
  if (!isObject(e)) return !1;
  var t = baseGetTag(e);
  return t == funcTag || t == genTag || t == asyncTag || t == proxyTag;
}

var isFunction_1 = isFunction,
    coreJsData = root["__core-js_shared__"],
    _coreJsData = coreJsData,
    maskSrcKey = (uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || ""), uid ? "Symbol(src)_1." + uid : ""),
    uid;

function isMasked(e) {
  return !!maskSrcKey && maskSrcKey in e;
}

var _isMasked = isMasked,
    funcProto = Function.prototype,
    funcToString = funcProto.toString;

function toSource(e) {
  if (null != e) {
    try {
      return funcToString.call(e);
    } catch (e) {}

    try {
      return e + "";
    } catch (e) {}
  }

  return "";
}

var _toSource = toSource,
    reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reIsHostCtor = /^\[object .+?Constructor\]$/,
    funcProto$1 = Function.prototype,
    objectProto = Object.prototype,
    funcToString$1 = funcProto$1.toString,
    hasOwnProperty = objectProto.hasOwnProperty,
    reIsNative = RegExp("^" + funcToString$1.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

function baseIsNative(e) {
  return !(!isObject(e) || _isMasked(e)) && (isFunction_1(e) ? reIsNative : reIsHostCtor).test(_toSource(e));
}

var _baseIsNative = baseIsNative;

function getValue(e, t) {
  return null == e ? void 0 : e[t];
}

var _getValue = getValue;

function getNative(e, t) {
  var r = _getValue(e, t);

  return _baseIsNative(r) ? r : void 0;
}

var _getNative = getNative,
    nativeCreate = _getNative(Object, "create"),
    _nativeCreate = nativeCreate;

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {}, this.size = 0;
}

var _hashClear = hashClear;

function hashDelete(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}

var _hashDelete = hashDelete,
    HASH_UNDEFINED = "__lodash_hash_undefined__",
    objectProto$1 = Object.prototype,
    hasOwnProperty$1 = objectProto$1.hasOwnProperty;

function hashGet(e) {
  var t = this.__data__;

  if (_nativeCreate) {
    var r = t[e];
    return r === HASH_UNDEFINED ? void 0 : r;
  }

  return hasOwnProperty$1.call(t, e) ? t[e] : void 0;
}

var _hashGet = hashGet,
    objectProto$2 = Object.prototype,
    hasOwnProperty$2 = objectProto$2.hasOwnProperty;

function hashHas(e) {
  var t = this.__data__;
  return _nativeCreate ? void 0 !== t[e] : hasOwnProperty$2.call(t, e);
}

var _hashHas = hashHas,
    HASH_UNDEFINED$1 = "__lodash_hash_undefined__";

function hashSet(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = _nativeCreate && void 0 === t ? HASH_UNDEFINED$1 : t, this;
}

var _hashSet = hashSet;

function Hash(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}

Hash.prototype.clear = _hashClear, Hash.prototype.delete = _hashDelete, Hash.prototype.get = _hashGet, Hash.prototype.has = _hashHas, Hash.prototype.set = _hashSet;
var _Hash = Hash;

function listCacheClear() {
  this.__data__ = [], this.size = 0;
}

var _listCacheClear = listCacheClear;

function eq(e, t) {
  return e === t || e != e && t != t;
}

var eq_1 = eq;

function assocIndexOf(e, t) {
  for (var r = e.length; r--;) {
    if (eq_1(e[r][0], t)) return r;
  }

  return -1;
}

var _assocIndexOf = assocIndexOf,
    arrayProto = Array.prototype,
    splice = arrayProto.splice;

function listCacheDelete(e) {
  var t = this.__data__,
      r = _assocIndexOf(t, e);

  return !(r < 0) && (r == t.length - 1 ? t.pop() : splice.call(t, r, 1), --this.size, !0);
}

var _listCacheDelete = listCacheDelete;

function listCacheGet(e) {
  var t = this.__data__,
      r = _assocIndexOf(t, e);

  return r < 0 ? void 0 : t[r][1];
}

var _listCacheGet = listCacheGet;

function listCacheHas(e) {
  return _assocIndexOf(this.__data__, e) > -1;
}

var _listCacheHas = listCacheHas;

function listCacheSet(e, t) {
  var r = this.__data__,
      a = _assocIndexOf(r, e);

  return a < 0 ? (++this.size, r.push([e, t])) : r[a][1] = t, this;
}

var _listCacheSet = listCacheSet;

function ListCache(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}

ListCache.prototype.clear = _listCacheClear, ListCache.prototype.delete = _listCacheDelete, ListCache.prototype.get = _listCacheGet, ListCache.prototype.has = _listCacheHas, ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache,
    Map = _getNative(root, "Map"),
    _Map = Map;

function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new _Hash(),
    map: new (_Map || _ListCache)(),
    string: new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;

function isKeyable(e) {
  var t = typeof e;
  return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
}

var _isKeyable = isKeyable;

function getMapData(e, t) {
  var r = e.__data__;
  return _isKeyable(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
}

var _getMapData = getMapData;

function mapCacheDelete(e) {
  var t = _getMapData(this, e).delete(e);

  return this.size -= t ? 1 : 0, t;
}

var _mapCacheDelete = mapCacheDelete;

function mapCacheGet(e) {
  return _getMapData(this, e).get(e);
}

var _mapCacheGet = mapCacheGet;

function mapCacheHas(e) {
  return _getMapData(this, e).has(e);
}

var _mapCacheHas = mapCacheHas;

function mapCacheSet(e, t) {
  var r = _getMapData(this, e),
      a = r.size;

  return r.set(e, t), this.size += r.size == a ? 0 : 1, this;
}

var _mapCacheSet = mapCacheSet;

function MapCache(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}

MapCache.prototype.clear = _mapCacheClear, MapCache.prototype.delete = _mapCacheDelete, MapCache.prototype.get = _mapCacheGet, MapCache.prototype.has = _mapCacheHas, MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache,
    HASH_UNDEFINED$2 = "__lodash_hash_undefined__";

function setCacheAdd(e) {
  return this.__data__.set(e, HASH_UNDEFINED$2), this;
}

var _setCacheAdd = setCacheAdd;

function setCacheHas(e) {
  return this.__data__.has(e);
}

var _setCacheHas = setCacheHas;

function SetCache(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.__data__ = new _MapCache(); ++t < r;) {
    this.add(e[t]);
  }
}

SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd, SetCache.prototype.has = _setCacheHas;
var _SetCache = SetCache;

function baseFindIndex(e, t, r, a) {
  for (var n = e.length, o = r + (a ? 1 : -1); a ? o-- : ++o < n;) {
    if (t(e[o], o, e)) return o;
  }

  return -1;
}

var _baseFindIndex = baseFindIndex;

function baseIsNaN(e) {
  return e != e;
}

var _baseIsNaN = baseIsNaN;

function strictIndexOf(e, t, r) {
  for (var a = r - 1, n = e.length; ++a < n;) {
    if (e[a] === t) return a;
  }

  return -1;
}

var _strictIndexOf = strictIndexOf;

function baseIndexOf(e, t, r) {
  return t == t ? _strictIndexOf(e, t, r) : _baseFindIndex(e, _baseIsNaN, r);
}

var _baseIndexOf = baseIndexOf;

function arrayIncludes(e, t) {
  return !!(null == e ? 0 : e.length) && _baseIndexOf(e, t, 0) > -1;
}

var _arrayIncludes = arrayIncludes;

function arrayIncludesWith(e, t, r) {
  for (var a = -1, n = null == e ? 0 : e.length; ++a < n;) {
    if (r(t, e[a])) return !0;
  }

  return !1;
}

var _arrayIncludesWith = arrayIncludesWith;

function arrayMap(e, t) {
  for (var r = -1, a = null == e ? 0 : e.length, n = Array(a); ++r < a;) {
    n[r] = t(e[r], r, e);
  }

  return n;
}

var _arrayMap = arrayMap;

function baseUnary(e) {
  return function (t) {
    return e(t);
  };
}

var _baseUnary = baseUnary;

function cacheHas(e, t) {
  return e.has(t);
}

var _cacheHas = cacheHas,
    LARGE_ARRAY_SIZE = 200;

function baseDifference(e, t, r, a) {
  var n = -1,
      o = _arrayIncludes,
      i = !0,
      s = e.length,
      l = [],
      u = t.length;
  if (!s) return l;
  r && (t = _arrayMap(t, _baseUnary(r))), a ? (o = _arrayIncludesWith, i = !1) : t.length >= LARGE_ARRAY_SIZE && (o = _cacheHas, i = !1, t = new _SetCache(t));

  e: for (; ++n < s;) {
    var c = e[n],
        _ = null == r ? c : r(c);

    if (c = a || 0 !== c ? c : 0, i && _ == _) {
      for (var p = u; p--;) {
        if (t[p] === _) continue e;
      }

      l.push(c);
    } else o(t, _, a) || l.push(c);
  }

  return l;
}

var _baseDifference = baseDifference;

function arrayPush(e, t) {
  for (var r = -1, a = t.length, n = e.length; ++r < a;) {
    e[n + r] = t[r];
  }

  return e;
}

var _arrayPush = arrayPush,
    argsTag = "[object Arguments]";

function baseIsArguments(e) {
  return isObjectLike(e) && baseGetTag(e) == argsTag;
}

var _baseIsArguments = baseIsArguments,
    objectProto$3 = Object.prototype,
    hasOwnProperty$3 = objectProto$3.hasOwnProperty,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable,
    isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (e) {
  return isObjectLike(e) && hasOwnProperty$3.call(e, "callee") && !propertyIsEnumerable.call(e, "callee");
},
    isArguments_1 = isArguments,
    isArray = Array.isArray,
    isArray_1 = isArray,
    spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;

function isFlattenable(e) {
  return isArray_1(e) || isArguments_1(e) || !!(spreadableSymbol && e && e[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;

function baseFlatten(e, t, r, a, n) {
  var o = -1,
      i = e.length;

  for (r || (r = _isFlattenable), n || (n = []); ++o < i;) {
    var s = e[o];
    t > 0 && r(s) ? t > 1 ? baseFlatten(s, t - 1, r, a, n) : _arrayPush(n, s) : a || (n[n.length] = s);
  }

  return n;
}

var _baseFlatten = baseFlatten;

function identity(e) {
  return e;
}

var identity_1 = identity;

function apply(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);

    case 1:
      return e.call(t, r[0]);

    case 2:
      return e.call(t, r[0], r[1]);

    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }

  return e.apply(t, r);
}

var _apply = apply,
    nativeMax = Math.max;

function overRest(e, t, r) {
  return t = nativeMax(void 0 === t ? e.length - 1 : t, 0), function () {
    for (var a = arguments, n = -1, o = nativeMax(a.length - t, 0), i = Array(o); ++n < o;) {
      i[n] = a[t + n];
    }

    n = -1;

    for (var s = Array(t + 1); ++n < t;) {
      s[n] = a[n];
    }

    return s[t] = r(i), _apply(e, this, s);
  };
}

var _overRest = overRest;

function constant(e) {
  return function () {
    return e;
  };
}

var constant_1 = constant,
    defineProperty = function () {
  try {
    var e = _getNative(Object, "defineProperty");

    return e({}, "", {}), e;
  } catch (e) {}
}(),
    _defineProperty = defineProperty,
    baseSetToString = _defineProperty ? function (e, t) {
  return _defineProperty(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant_1(t),
    writable: !0
  });
} : identity_1,
    _baseSetToString = baseSetToString,
    HOT_COUNT = 800,
    HOT_SPAN = 16,
    nativeNow = Date.now;

function shortOut(e) {
  var t = 0,
      r = 0;
  return function () {
    var a = nativeNow(),
        n = HOT_SPAN - (a - r);

    if (r = a, n > 0) {
      if (++t >= HOT_COUNT) return arguments[0];
    } else t = 0;

    return e.apply(void 0, arguments);
  };
}

var _shortOut = shortOut,
    setToString = _shortOut(_baseSetToString),
    _setToString = setToString;

function baseRest(e, t) {
  return _setToString(_overRest(e, t, identity_1), e + "");
}

var _baseRest = baseRest,
    MAX_SAFE_INTEGER = 9007199254740991;

function isLength(e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

function isArrayLike(e) {
  return null != e && isLength_1(e.length) && !isFunction_1(e);
}

var isArrayLike_1 = isArrayLike;

function isArrayLikeObject(e) {
  return isObjectLike(e) && isArrayLike_1(e);
}

var isArrayLikeObject_1 = isArrayLikeObject,
    difference = _baseRest(function (e, t) {
  return isArrayLikeObject_1(e) ? _baseDifference(e, _baseFlatten(t, 1, isArrayLikeObject_1, !0)) : [];
}),
    difference_1 = difference,
    Set = _getNative(root, "Set"),
    _Set = Set;

function noop() {}

var noop_1 = noop;

function setToArray(e) {
  var t = -1,
      r = Array(e.size);
  return e.forEach(function (e) {
    r[++t] = e;
  }), r;
}

var _setToArray = setToArray,
    INFINITY = 1 / 0,
    createSet = _Set && 1 / _setToArray(new _Set([, -0]))[1] == INFINITY ? function (e) {
  return new _Set(e);
} : noop_1,
    _createSet = createSet,
    LARGE_ARRAY_SIZE$1 = 200;

function baseUniq(e, t, r) {
  var a = -1,
      n = _arrayIncludes,
      o = e.length,
      i = !0,
      s = [],
      l = s;
  if (r) i = !1, n = _arrayIncludesWith;else if (o >= LARGE_ARRAY_SIZE$1) {
    var u = t ? null : _createSet(e);
    if (u) return _setToArray(u);
    i = !1, n = _cacheHas, l = new _SetCache();
  } else l = t ? [] : s;

  e: for (; ++a < o;) {
    var c = e[a],
        _ = t ? t(c) : c;

    if (c = r || 0 !== c ? c : 0, i && _ == _) {
      for (var p = l.length; p--;) {
        if (l[p] === _) continue e;
      }

      t && l.push(_), s.push(c);
    } else n(l, _, r) || (l !== s && l.push(_), s.push(c));
  }

  return s;
}

var _baseUniq = baseUniq;

function uniq(e) {
  return e && e.length ? _baseUniq(e) : [];
}

var uniq_1 = uniq;

function stackClear() {
  this.__data__ = new _ListCache(), this.size = 0;
}

var _stackClear = stackClear;

function stackDelete(e) {
  var t = this.__data__,
      r = t.delete(e);
  return this.size = t.size, r;
}

var _stackDelete = stackDelete;

function stackGet(e) {
  return this.__data__.get(e);
}

var _stackGet = stackGet;

function stackHas(e) {
  return this.__data__.has(e);
}

var _stackHas = stackHas,
    LARGE_ARRAY_SIZE$2 = 200;

function stackSet(e, t) {
  var r = this.__data__;

  if (r instanceof _ListCache) {
    var a = r.__data__;
    if (!_Map || a.length < LARGE_ARRAY_SIZE$2 - 1) return a.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new _MapCache(a);
  }

  return r.set(e, t), this.size = r.size, this;
}

var _stackSet = stackSet;

function Stack(e) {
  var t = this.__data__ = new _ListCache(e);
  this.size = t.size;
}

Stack.prototype.clear = _stackClear, Stack.prototype.delete = _stackDelete, Stack.prototype.get = _stackGet, Stack.prototype.has = _stackHas, Stack.prototype.set = _stackSet;
var _Stack = Stack;

function arraySome(e, t) {
  for (var r = -1, a = null == e ? 0 : e.length; ++r < a;) {
    if (t(e[r], r, e)) return !0;
  }

  return !1;
}

var _arraySome = arraySome,
    COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

function equalArrays(e, t, r, a, n, o) {
  var i = r & COMPARE_PARTIAL_FLAG,
      s = e.length,
      l = t.length;
  if (s != l && !(i && l > s)) return !1;
  var u = o.get(e);
  if (u && o.get(t)) return u == t;

  var c = -1,
      _ = !0,
      p = r & COMPARE_UNORDERED_FLAG ? new _SetCache() : void 0;

  for (o.set(e, t), o.set(t, e); ++c < s;) {
    var h = e[c],
        f = t[c];
    if (a) var T = i ? a(f, h, c, t, e, o) : a(h, f, c, e, t, o);

    if (void 0 !== T) {
      if (T) continue;
      _ = !1;
      break;
    }

    if (p) {
      if (!_arraySome(t, function (e, t) {
        if (!_cacheHas(p, t) && (h === e || n(h, e, r, a, o))) return p.push(t);
      })) {
        _ = !1;
        break;
      }
    } else if (h !== f && !n(h, f, r, a, o)) {
      _ = !1;
      break;
    }
  }

  return o.delete(e), o.delete(t), _;
}

var _equalArrays = equalArrays,
    Uint8Array$1 = root.Uint8Array,
    _Uint8Array = Uint8Array$1;

function mapToArray(e) {
  var t = -1,
      r = Array(e.size);
  return e.forEach(function (e, a) {
    r[++t] = [a, e];
  }), r;
}

var _mapToArray = mapToArray,
    COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2,
    boolTag = "[object Boolean]",
    dateTag = "[object Date]",
    errorTag = "[object Error]",
    mapTag = "[object Map]",
    numberTag = "[object Number]",
    regexpTag = "[object RegExp]",
    setTag = "[object Set]",
    stringTag = "[object String]",
    symbolTag = "[object Symbol]",
    arrayBufferTag = "[object ArrayBuffer]",
    dataViewTag = "[object DataView]",
    symbolProto = Symbol$1 ? Symbol$1.prototype : void 0,
    symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;

function equalByTag(e, t, r, a, n, o, i) {
  switch (r) {
    case dataViewTag:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
      e = e.buffer, t = t.buffer;

    case arrayBufferTag:
      return !(e.byteLength != t.byteLength || !o(new _Uint8Array(e), new _Uint8Array(t)));

    case boolTag:
    case dateTag:
    case numberTag:
      return eq_1(+e, +t);

    case errorTag:
      return e.name == t.name && e.message == t.message;

    case regexpTag:
    case stringTag:
      return e == t + "";

    case mapTag:
      var s = _mapToArray;

    case setTag:
      var l = a & COMPARE_PARTIAL_FLAG$1;
      if (s || (s = _setToArray), e.size != t.size && !l) return !1;
      var u = i.get(e);
      if (u) return u == t;
      a |= COMPARE_UNORDERED_FLAG$1, i.set(e, t);

      var c = _equalArrays(s(e), s(t), a, n, o, i);

      return i.delete(e), c;

    case symbolTag:
      if (symbolValueOf) return symbolValueOf.call(e) == symbolValueOf.call(t);
  }

  return !1;
}

var _equalByTag = equalByTag;

function baseGetAllKeys(e, t, r) {
  var a = t(e);
  return isArray_1(e) ? a : _arrayPush(a, r(e));
}

var _baseGetAllKeys = baseGetAllKeys;

function arrayFilter(e, t) {
  for (var r = -1, a = null == e ? 0 : e.length, n = 0, o = []; ++r < a;) {
    var i = e[r];
    t(i, r, e) && (o[n++] = i);
  }

  return o;
}

var _arrayFilter = arrayFilter;

function stubArray() {
  return [];
}

var stubArray_1 = stubArray,
    objectProto$4 = Object.prototype,
    propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable,
    nativeGetSymbols = Object.getOwnPropertySymbols,
    getSymbols = nativeGetSymbols ? function (e) {
  return null == e ? [] : (e = Object(e), _arrayFilter(nativeGetSymbols(e), function (t) {
    return propertyIsEnumerable$1.call(e, t);
  }));
} : stubArray_1,
    _getSymbols = getSymbols;

function baseTimes(e, t) {
  for (var r = -1, a = Array(e); ++r < e;) {
    a[r] = t(r);
  }

  return a;
}

var _baseTimes = baseTimes;

function stubFalse() {
  return !1;
}

var stubFalse_1 = stubFalse,
    isBuffer_1 = createCommonjsModule(function (e, t) {
  var r = t && !t.nodeType && t,
      a = r && e && !e.nodeType && e,
      n = a && a.exports === r ? root.Buffer : void 0,
      o = (n ? n.isBuffer : void 0) || stubFalse_1;
  e.exports = o;
}),
    MAX_SAFE_INTEGER$1 = 9007199254740991,
    reIsUint = /^(?:0|[1-9]\d*)$/;

function isIndex(e, t) {
  var r = typeof e;
  return !!(t = null == t ? MAX_SAFE_INTEGER$1 : t) && ("number" == r || "symbol" != r && reIsUint.test(e)) && e > -1 && e % 1 == 0 && e < t;
}

var _isIndex = isIndex,
    argsTag$1 = "[object Arguments]",
    arrayTag = "[object Array]",
    boolTag$1 = "[object Boolean]",
    dateTag$1 = "[object Date]",
    errorTag$1 = "[object Error]",
    funcTag$1 = "[object Function]",
    mapTag$1 = "[object Map]",
    numberTag$1 = "[object Number]",
    objectTag = "[object Object]",
    regexpTag$1 = "[object RegExp]",
    setTag$1 = "[object Set]",
    stringTag$1 = "[object String]",
    weakMapTag = "[object WeakMap]",
    arrayBufferTag$1 = "[object ArrayBuffer]",
    dataViewTag$1 = "[object DataView]",
    float32Tag = "[object Float32Array]",
    float64Tag = "[object Float64Array]",
    int8Tag = "[object Int8Array]",
    int16Tag = "[object Int16Array]",
    int32Tag = "[object Int32Array]",
    uint8Tag = "[object Uint8Array]",
    uint8ClampedTag = "[object Uint8ClampedArray]",
    uint16Tag = "[object Uint16Array]",
    uint32Tag = "[object Uint32Array]",
    typedArrayTags = {};

function baseIsTypedArray(e) {
  return isObjectLike(e) && isLength_1(e.length) && !!typedArrayTags[baseGetTag(e)];
}

typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0, typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = !1;

var _baseIsTypedArray = baseIsTypedArray,
    _nodeUtil = createCommonjsModule(function (e, t) {
  var r = t && !t.nodeType && t,
      a = r && e && !e.nodeType && e,
      n = a && a.exports === r && freeGlobal.process,
      o = function () {
    try {
      var e = a && a.require && a.require("util").types;

      return e || n && n.binding && n.binding("util");
    } catch (e) {}
  }();

  e.exports = o;
}),
    nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray,
    isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray,
    isTypedArray_1 = isTypedArray,
    objectProto$5 = Object.prototype,
    hasOwnProperty$4 = objectProto$5.hasOwnProperty;

function arrayLikeKeys(e, t) {
  var r = isArray_1(e),
      a = !r && isArguments_1(e),
      n = !r && !a && isBuffer_1(e),
      o = !r && !a && !n && isTypedArray_1(e),
      i = r || a || n || o,
      s = i ? _baseTimes(e.length, String) : [],
      l = s.length;

  for (var u in e) {
    !t && !hasOwnProperty$4.call(e, u) || i && ("length" == u || n && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || _isIndex(u, l)) || s.push(u);
  }

  return s;
}

var _arrayLikeKeys = arrayLikeKeys,
    objectProto$6 = Object.prototype;

function isPrototype(e) {
  var t = e && e.constructor;
  return e === ("function" == typeof t && t.prototype || objectProto$6);
}

var _isPrototype = isPrototype;

function overArg(e, t) {
  return function (r) {
    return e(t(r));
  };
}

var _overArg = overArg,
    nativeKeys = _overArg(Object.keys, Object),
    _nativeKeys = nativeKeys,
    objectProto$7 = Object.prototype,
    hasOwnProperty$5 = objectProto$7.hasOwnProperty;

function baseKeys(e) {
  if (!_isPrototype(e)) return _nativeKeys(e);
  var t = [];

  for (var r in Object(e)) {
    hasOwnProperty$5.call(e, r) && "constructor" != r && t.push(r);
  }

  return t;
}

var _baseKeys = baseKeys;

function keys(e) {
  return isArrayLike_1(e) ? _arrayLikeKeys(e) : _baseKeys(e);
}

var keys_1 = keys;

function getAllKeys(e) {
  return _baseGetAllKeys(e, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys,
    COMPARE_PARTIAL_FLAG$2 = 1,
    objectProto$8 = Object.prototype,
    hasOwnProperty$6 = objectProto$8.hasOwnProperty;

function equalObjects(e, t, r, a, n, o) {
  var i = r & COMPARE_PARTIAL_FLAG$2,
      s = _getAllKeys(e),
      l = s.length;

  if (l != _getAllKeys(t).length && !i) return !1;

  for (var u = l; u--;) {
    var c = s[u];
    if (!(i ? c in t : hasOwnProperty$6.call(t, c))) return !1;
  }

  var _ = o.get(e);

  if (_ && o.get(t)) return _ == t;
  var p = !0;
  o.set(e, t), o.set(t, e);

  for (var h = i; ++u < l;) {
    var f = e[c = s[u]],
        T = t[c];
    if (a) var d = i ? a(T, f, c, t, e, o) : a(f, T, c, e, t, o);

    if (!(void 0 === d ? f === T || n(f, T, r, a, o) : d)) {
      p = !1;
      break;
    }

    h || (h = "constructor" == c);
  }

  if (p && !h) {
    var E = e.constructor,
        y = t.constructor;
    E != y && "constructor" in e && "constructor" in t && !("function" == typeof E && E instanceof E && "function" == typeof y && y instanceof y) && (p = !1);
  }

  return o.delete(e), o.delete(t), p;
}

var _equalObjects = equalObjects,
    DataView$1 = _getNative(root, "DataView"),
    _DataView = DataView$1,
    Promise$1 = _getNative(root, "Promise"),
    _Promise = Promise$1,
    WeakMap = _getNative(root, "WeakMap"),
    _WeakMap = WeakMap,
    mapTag$2 = "[object Map]",
    objectTag$1 = "[object Object]",
    promiseTag = "[object Promise]",
    setTag$2 = "[object Set]",
    weakMapTag$1 = "[object WeakMap]",
    dataViewTag$2 = "[object DataView]",
    dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap),
    getTag = baseGetTag;

(_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2 || _Map && getTag(new _Map()) != mapTag$2 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$2 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) && (getTag = function getTag(e) {
  var t = baseGetTag(e),
      r = t == objectTag$1 ? e.constructor : void 0,
      a = r ? _toSource(r) : "";
  if (a) switch (a) {
    case dataViewCtorString:
      return dataViewTag$2;

    case mapCtorString:
      return mapTag$2;

    case promiseCtorString:
      return promiseTag;

    case setCtorString:
      return setTag$2;

    case weakMapCtorString:
      return weakMapTag$1;
  }
  return t;
});
var _getTag = getTag,
    COMPARE_PARTIAL_FLAG$3 = 1,
    argsTag$2 = "[object Arguments]",
    arrayTag$1 = "[object Array]",
    objectTag$2 = "[object Object]",
    objectProto$9 = Object.prototype,
    hasOwnProperty$7 = objectProto$9.hasOwnProperty;

function baseIsEqualDeep(e, t, r, a, n, o) {
  var i = isArray_1(e),
      s = isArray_1(t),
      l = i ? arrayTag$1 : _getTag(e),
      u = s ? arrayTag$1 : _getTag(t),
      c = (l = l == argsTag$2 ? objectTag$2 : l) == objectTag$2,
      _ = (u = u == argsTag$2 ? objectTag$2 : u) == objectTag$2,
      p = l == u;

  if (p && isBuffer_1(e)) {
    if (!isBuffer_1(t)) return !1;
    i = !0, c = !1;
  }

  if (p && !c) return o || (o = new _Stack()), i || isTypedArray_1(e) ? _equalArrays(e, t, r, a, n, o) : _equalByTag(e, t, l, r, a, n, o);

  if (!(r & COMPARE_PARTIAL_FLAG$3)) {
    var h = c && hasOwnProperty$7.call(e, "__wrapped__"),
        f = _ && hasOwnProperty$7.call(t, "__wrapped__");

    if (h || f) {
      var T = h ? e.value() : e,
          d = f ? t.value() : t;
      return o || (o = new _Stack()), n(T, d, r, a, o);
    }
  }

  return !!p && (o || (o = new _Stack()), _equalObjects(e, t, r, a, n, o));
}

var _baseIsEqualDeep = baseIsEqualDeep;

function baseIsEqual(e, t, r, a, n) {
  return e === t || (null == e || null == t || !isObjectLike(e) && !isObjectLike(t) ? e != e && t != t : _baseIsEqualDeep(e, t, r, a, baseIsEqual, n));
}

var _baseIsEqual = baseIsEqual,
    COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

function baseIsMatch(e, t, r, a) {
  var n = r.length,
      o = n,
      i = !a;
  if (null == e) return !o;

  for (e = Object(e); n--;) {
    var s = r[n];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
  }

  for (; ++n < o;) {
    var l = (s = r[n])[0],
        u = e[l],
        c = s[1];

    if (i && s[2]) {
      if (void 0 === u && !(l in e)) return !1;
    } else {
      var _ = new _Stack();

      if (a) var p = a(u, c, l, e, t, _);
      if (!(void 0 === p ? _baseIsEqual(c, u, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, a, _) : p)) return !1;
    }
  }

  return !0;
}

var _baseIsMatch = baseIsMatch;

function isStrictComparable(e) {
  return e == e && !isObject(e);
}

var _isStrictComparable = isStrictComparable;

function getMatchData(e) {
  for (var t = keys_1(e), r = t.length; r--;) {
    var a = t[r],
        n = e[a];
    t[r] = [a, n, _isStrictComparable(n)];
  }

  return t;
}

var _getMatchData = getMatchData;

function matchesStrictComparable(e, t) {
  return function (r) {
    return null != r && r[e] === t && (void 0 !== t || e in Object(r));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

function baseMatches(e) {
  var t = _getMatchData(e);

  return 1 == t.length && t[0][2] ? _matchesStrictComparable(t[0][0], t[0][1]) : function (r) {
    return r === e || _baseIsMatch(r, e, t);
  };
}

var _baseMatches = baseMatches,
    reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

function isKey(e, t) {
  if (isArray_1(e)) return !1;
  var r = typeof e;
  return !("number" != r && "symbol" != r && "boolean" != r && null != e && !isSymbol(e)) || reIsPlainProp.test(e) || !reIsDeepProp.test(e) || null != t && e in Object(t);
}

var _isKey = isKey,
    FUNC_ERROR_TEXT = "Expected a function";

function memoize(e, t) {
  if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(FUNC_ERROR_TEXT);

  var r = function r() {
    var a = arguments,
        n = t ? t.apply(this, a) : a[0],
        o = r.cache;
    if (o.has(n)) return o.get(n);
    var i = e.apply(this, a);
    return r.cache = o.set(n, i) || o, i;
  };

  return r.cache = new (memoize.Cache || _MapCache)(), r;
}

memoize.Cache = _MapCache;
var memoize_1 = memoize,
    MAX_MEMOIZE_SIZE = 500;

function memoizeCapped(e) {
  var t = memoize_1(e, function (e) {
    return r.size === MAX_MEMOIZE_SIZE && r.clear(), e;
  }),
      r = t.cache;
  return t;
}

var _memoizeCapped = memoizeCapped,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    reEscapeChar = /\\(\\)?/g,
    stringToPath = _memoizeCapped(function (e) {
  var t = [];
  return 46 === e.charCodeAt(0) && t.push(""), e.replace(rePropName, function (e, r, a, n) {
    t.push(a ? n.replace(reEscapeChar, "$1") : r || e);
  }), t;
}),
    _stringToPath = stringToPath,
    INFINITY$1 = 1 / 0,
    symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;

function baseToString(e) {
  if ("string" == typeof e) return e;
  if (isArray_1(e)) return _arrayMap(e, baseToString) + "";
  if (isSymbol(e)) return symbolToString ? symbolToString.call(e) : "";
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY$1 ? "-0" : t;
}

var _baseToString = baseToString;

function toString(e) {
  return null == e ? "" : _baseToString(e);
}

var toString_1 = toString;

function castPath(e, t) {
  return isArray_1(e) ? e : _isKey(e, t) ? [e] : _stringToPath(toString_1(e));
}

var _castPath = castPath,
    INFINITY$2 = 1 / 0;

function toKey(e) {
  if ("string" == typeof e || isSymbol(e)) return e;
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY$2 ? "-0" : t;
}

var _toKey = toKey;

function baseGet(e, t) {
  for (var r = 0, a = (t = _castPath(t, e)).length; null != e && r < a;) {
    e = e[_toKey(t[r++])];
  }

  return r && r == a ? e : void 0;
}

var _baseGet = baseGet;

function get(e, t, r) {
  var a = null == e ? void 0 : _baseGet(e, t);
  return void 0 === a ? r : a;
}

var get_1 = get;

function baseHasIn(e, t) {
  return null != e && t in Object(e);
}

var _baseHasIn = baseHasIn;

function hasPath(e, t, r) {
  for (var a = -1, n = (t = _castPath(t, e)).length, o = !1; ++a < n;) {
    var i = _toKey(t[a]);

    if (!(o = null != e && r(e, i))) break;
    e = e[i];
  }

  return o || ++a != n ? o : !!(n = null == e ? 0 : e.length) && isLength_1(n) && _isIndex(i, n) && (isArray_1(e) || isArguments_1(e));
}

var _hasPath = hasPath;

function hasIn(e, t) {
  return null != e && _hasPath(e, t, _baseHasIn);
}

var hasIn_1 = hasIn,
    COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

function baseMatchesProperty(e, t) {
  return _isKey(e) && _isStrictComparable(t) ? _matchesStrictComparable(_toKey(e), t) : function (r) {
    var a = get_1(r, e);
    return void 0 === a && a === t ? hasIn_1(r, e) : _baseIsEqual(t, a, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

function baseProperty(e) {
  return function (t) {
    return null == t ? void 0 : t[e];
  };
}

var _baseProperty = baseProperty;

function basePropertyDeep(e) {
  return function (t) {
    return _baseGet(t, e);
  };
}

var _basePropertyDeep = basePropertyDeep;

function property(e) {
  return _isKey(e) ? _baseProperty(_toKey(e)) : _basePropertyDeep(e);
}

var property_1 = property;

function baseIteratee(e) {
  return "function" == typeof e ? e : null == e ? identity_1 : "object" == typeof e ? isArray_1(e) ? _baseMatchesProperty(e[0], e[1]) : _baseMatches(e) : property_1(e);
}

var _baseIteratee = baseIteratee;

function uniqBy(e, t) {
  return e && e.length ? _baseUniq(e, _baseIteratee(t)) : [];
}

var uniqBy_1 = uniqBy;

function baseIndexOfWith(e, t, r, a) {
  for (var n = r - 1, o = e.length; ++n < o;) {
    if (a(e[n], t)) return n;
  }

  return -1;
}

var _baseIndexOfWith = baseIndexOfWith;

function copyArray(e, t) {
  var r = -1,
      a = e.length;

  for (t || (t = Array(a)); ++r < a;) {
    t[r] = e[r];
  }

  return t;
}

var _copyArray = copyArray,
    arrayProto$1 = Array.prototype,
    splice$1 = arrayProto$1.splice;

function basePullAll(e, t, r, a) {
  var n = a ? _baseIndexOfWith : _baseIndexOf,
      o = -1,
      i = t.length,
      s = e;

  for (e === t && (t = _copyArray(t)), r && (s = _arrayMap(e, _baseUnary(r))); ++o < i;) {
    for (var l = 0, u = t[o], c = r ? r(u) : u; (l = n(s, c, l, a)) > -1;) {
      s !== e && splice$1.call(s, l, 1), splice$1.call(e, l, 1);
    }
  }

  return e;
}

var _basePullAll = basePullAll;

function pullAll(e, t) {
  return e && e.length && t && t.length ? _basePullAll(e, t) : e;
}

var pullAll_1 = pullAll,
    pull = _baseRest(pullAll_1),
    pull_1 = pull;

function baseSum(e, t) {
  for (var r, a = -1, n = e.length; ++a < n;) {
    var o = t(e[a]);
    void 0 !== o && (r = void 0 === r ? o : r + o);
  }

  return r;
}

var _baseSum = baseSum;

function sumBy(e, t) {
  return e && e.length ? _baseSum(e, _baseIteratee(t)) : 0;
}

var sumBy_1 = sumBy;

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}

function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" !== _typeof(t) && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArrayLimit(e, t) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
    var r = [],
        a = !0,
        n = !1,
        o = void 0;

    try {
      for (var i, s = e[Symbol.iterator](); !(a = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); a = !0) {
        ;
      }
    } catch (e) {
      n = !0, o = e;
    } finally {
      try {
        a || null == s.return || s.return();
      } finally {
        if (n) throw o;
      }
    }

    return r;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _nonIterableRest();
}

var EPSILON = 1e-6,
    ARRAY_TYPE = "undefined" != typeof Float32Array ? Float32Array : Array;

function create() {
  var e = new ARRAY_TYPE(4);
  return ARRAY_TYPE != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0), e;
}

function scale(e, t, r) {
  return e[0] = t[0] * r, e[1] = t[1] * r, e[2] = t[2] * r, e[3] = t[3] * r, e;
}

function transformMat4(e, t, r) {
  var a = t[0],
      n = t[1],
      o = t[2],
      i = t[3];
  return e[0] = r[0] * a + r[4] * n + r[8] * o + r[12] * i, e[1] = r[1] * a + r[5] * n + r[9] * o + r[13] * i, e[2] = r[2] * a + r[6] * n + r[10] * o + r[14] * i, e[3] = r[3] * a + r[7] * n + r[11] * o + r[15] * i, e;
}

Math.hypot || (Math.hypot = function () {
  for (var e = 0, t = arguments.length; t--;) {
    e += arguments[t] * arguments[t];
  }

  return Math.sqrt(e);
});
var forEach = (vec = create(), function (e, t, r, a, n, o) {
  var i, s;

  for (t || (t = 4), r || (r = 0), s = a ? Math.min(a * t + r, e.length) : e.length, i = r; i < s; i += t) {
    vec[0] = e[i], vec[1] = e[i + 1], vec[2] = e[i + 2], vec[3] = e[i + 3], n(vec, vec, o), e[i] = vec[0], e[i + 1] = vec[1], e[i + 2] = vec[2], e[i + 3] = vec[3];
  }

  return e;
}),
    vec;

function createMat4() {
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}

function transformVector(e, t) {
  var r = transformMat4([], t, e);
  return scale(r, r, 1 / r[3]), r;
}

function invert(e, t) {
  var r = t[0],
      a = t[1],
      n = t[2],
      o = t[3],
      i = t[4],
      s = t[5],
      l = t[6],
      u = t[7],
      c = t[8],
      _ = t[9],
      p = t[10],
      h = t[11],
      f = t[12],
      T = t[13],
      d = t[14],
      E = t[15],
      y = r * s - a * i,
      g = r * l - n * i,
      v = r * u - o * i,
      A = a * l - n * s,
      b = a * u - o * s,
      m = n * u - o * l,
      S = c * T - _ * f,
      I = c * d - p * f,
      L = c * E - h * f,
      M = _ * d - p * T,
      P = _ * E - h * T,
      O = p * E - h * d,
      R = y * O - g * P + v * M + A * L - b * I + m * S;
  return R ? (R = 1 / R, e[0] = (s * O - l * P + u * M) * R, e[1] = (n * P - a * O - o * M) * R, e[2] = (T * m - d * b + E * A) * R, e[3] = (p * b - _ * m - h * A) * R, e[4] = (l * L - i * O - u * I) * R, e[5] = (r * O - n * L + o * I) * R, e[6] = (d * v - f * m - E * g) * R, e[7] = (c * m - p * v + h * g) * R, e[8] = (i * P - s * L + u * S) * R, e[9] = (a * L - r * P - o * S) * R, e[10] = (f * b - T * v + E * y) * R, e[11] = (_ * v - c * b - h * y) * R, e[12] = (s * I - i * M - l * S) * R, e[13] = (r * M - a * I + n * S) * R, e[14] = (T * g - f * A - d * y) * R, e[15] = (c * A - _ * g + p * y) * R, e) : null;
}

function multiply(e, t, r) {
  var a = t[0],
      n = t[1],
      o = t[2],
      i = t[3],
      s = t[4],
      l = t[5],
      u = t[6],
      c = t[7],
      _ = t[8],
      p = t[9],
      h = t[10],
      f = t[11],
      T = t[12],
      d = t[13],
      E = t[14],
      y = t[15],
      g = r[0],
      v = r[1],
      A = r[2],
      b = r[3];
  return e[0] = g * a + v * s + A * _ + b * T, e[1] = g * n + v * l + A * p + b * d, e[2] = g * o + v * u + A * h + b * E, e[3] = g * i + v * c + A * f + b * y, g = r[4], v = r[5], A = r[6], b = r[7], e[4] = g * a + v * s + A * _ + b * T, e[5] = g * n + v * l + A * p + b * d, e[6] = g * o + v * u + A * h + b * E, e[7] = g * i + v * c + A * f + b * y, g = r[8], v = r[9], A = r[10], b = r[11], e[8] = g * a + v * s + A * _ + b * T, e[9] = g * n + v * l + A * p + b * d, e[10] = g * o + v * u + A * h + b * E, e[11] = g * i + v * c + A * f + b * y, g = r[12], v = r[13], A = r[14], b = r[15], e[12] = g * a + v * s + A * _ + b * T, e[13] = g * n + v * l + A * p + b * d, e[14] = g * o + v * u + A * h + b * E, e[15] = g * i + v * c + A * f + b * y, e;
}

function translate(e, t, r) {
  var a,
      n,
      o,
      i,
      s,
      l,
      u,
      c,
      _,
      p,
      h,
      f,
      T = r[0],
      d = r[1],
      E = r[2];

  return t === e ? (e[12] = t[0] * T + t[4] * d + t[8] * E + t[12], e[13] = t[1] * T + t[5] * d + t[9] * E + t[13], e[14] = t[2] * T + t[6] * d + t[10] * E + t[14], e[15] = t[3] * T + t[7] * d + t[11] * E + t[15]) : (a = t[0], n = t[1], o = t[2], i = t[3], s = t[4], l = t[5], u = t[6], c = t[7], _ = t[8], p = t[9], h = t[10], f = t[11], e[0] = a, e[1] = n, e[2] = o, e[3] = i, e[4] = s, e[5] = l, e[6] = u, e[7] = c, e[8] = _, e[9] = p, e[10] = h, e[11] = f, e[12] = a * T + s * d + _ * E + t[12], e[13] = n * T + l * d + p * E + t[13], e[14] = o * T + u * d + h * E + t[14], e[15] = i * T + c * d + f * E + t[15]), e;
}

function scale$1(e, t, r) {
  var a = r[0],
      n = r[1],
      o = r[2];
  return e[0] = t[0] * a, e[1] = t[1] * a, e[2] = t[2] * a, e[3] = t[3] * a, e[4] = t[4] * n, e[5] = t[5] * n, e[6] = t[6] * n, e[7] = t[7] * n, e[8] = t[8] * o, e[9] = t[9] * o, e[10] = t[10] * o, e[11] = t[11] * o, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
}

function rotateX(e, t, r) {
  var a = Math.sin(r),
      n = Math.cos(r),
      o = t[4],
      i = t[5],
      s = t[6],
      l = t[7],
      u = t[8],
      c = t[9],
      _ = t[10],
      p = t[11];
  return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = o * n + u * a, e[5] = i * n + c * a, e[6] = s * n + _ * a, e[7] = l * n + p * a, e[8] = u * n - o * a, e[9] = c * n - i * a, e[10] = _ * n - s * a, e[11] = p * n - l * a, e;
}

function rotateZ(e, t, r) {
  var a = Math.sin(r),
      n = Math.cos(r),
      o = t[0],
      i = t[1],
      s = t[2],
      l = t[3],
      u = t[4],
      c = t[5],
      _ = t[6],
      p = t[7];
  return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = o * n + u * a, e[1] = i * n + c * a, e[2] = s * n + _ * a, e[3] = l * n + p * a, e[4] = u * n - o * a, e[5] = c * n - i * a, e[6] = _ * n - s * a, e[7] = p * n - l * a, e;
}

function perspective(e, t, r, a, n) {
  var o,
      i = 1 / Math.tan(t / 2);
  return e[0] = i / r, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = -1, e[12] = 0, e[13] = 0, e[15] = 0, null != n && n !== 1 / 0 ? (o = 1 / (a - n), e[10] = (n + a) * o, e[14] = 2 * n * a * o) : (e[10] = -1, e[14] = -2 * a), e;
}

function equals(e, t) {
  var r = e[0],
      a = e[1],
      n = e[2],
      o = e[3],
      i = e[4],
      s = e[5],
      l = e[6],
      u = e[7],
      c = e[8],
      _ = e[9],
      p = e[10],
      h = e[11],
      f = e[12],
      T = e[13],
      d = e[14],
      E = e[15],
      y = t[0],
      g = t[1],
      v = t[2],
      A = t[3],
      b = t[4],
      m = t[5],
      S = t[6],
      I = t[7],
      L = t[8],
      M = t[9],
      P = t[10],
      O = t[11],
      R = t[12],
      C = t[13],
      D = t[14],
      N = t[15];
  return Math.abs(r - y) <= EPSILON * Math.max(1, Math.abs(r), Math.abs(y)) && Math.abs(a - g) <= EPSILON * Math.max(1, Math.abs(a), Math.abs(g)) && Math.abs(n - v) <= EPSILON * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(o - A) <= EPSILON * Math.max(1, Math.abs(o), Math.abs(A)) && Math.abs(i - b) <= EPSILON * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(s - m) <= EPSILON * Math.max(1, Math.abs(s), Math.abs(m)) && Math.abs(l - S) <= EPSILON * Math.max(1, Math.abs(l), Math.abs(S)) && Math.abs(u - I) <= EPSILON * Math.max(1, Math.abs(u), Math.abs(I)) && Math.abs(c - L) <= EPSILON * Math.max(1, Math.abs(c), Math.abs(L)) && Math.abs(_ - M) <= EPSILON * Math.max(1, Math.abs(_), Math.abs(M)) && Math.abs(p - P) <= EPSILON * Math.max(1, Math.abs(p), Math.abs(P)) && Math.abs(h - O) <= EPSILON * Math.max(1, Math.abs(h), Math.abs(O)) && Math.abs(f - R) <= EPSILON * Math.max(1, Math.abs(f), Math.abs(R)) && Math.abs(T - C) <= EPSILON * Math.max(1, Math.abs(T), Math.abs(C)) && Math.abs(d - D) <= EPSILON * Math.max(1, Math.abs(d), Math.abs(D)) && Math.abs(E - N) <= EPSILON * Math.max(1, Math.abs(E), Math.abs(N));
}

function create$1() {
  var e = new ARRAY_TYPE(2);
  return ARRAY_TYPE != Float32Array && (e[0] = 0, e[1] = 0), e;
}

function add(e, t, r) {
  return e[0] = t[0] + r[0], e[1] = t[1] + r[1], e;
}

function negate(e, t) {
  return e[0] = -t[0], e[1] = -t[1], e;
}

function lerp(e, t, r, a) {
  var n = t[0],
      o = t[1];
  return e[0] = n + a * (r[0] - n), e[1] = o + a * (r[1] - o), e;
}

var forEach$1 = function () {
  var e = create$1();
  return function (t, r, a, n, o, i) {
    var s, l;

    for (r || (r = 2), a || (a = 0), l = n ? Math.min(n * r + a, t.length) : t.length, s = a; s < l; s += r) {
      e[0] = t[s], e[1] = t[s + 1], o(e, e, i), t[s] = e[0], t[s + 1] = e[1];
    }

    return t;
  };
}();

function create$2() {
  var e = new ARRAY_TYPE(3);
  return ARRAY_TYPE != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e;
}

function negate$1(e, t) {
  return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e;
}

var forEach$2 = function () {
  var e = create$2();
  return function (t, r, a, n, o, i) {
    var s, l;

    for (r || (r = 3), a || (a = 0), l = n ? Math.min(n * r + a, t.length) : t.length, s = a; s < l; s += r) {
      e[0] = t[s], e[1] = t[s + 1], e[2] = t[s + 2], o(e, e, i), t[s] = e[0], t[s + 1] = e[1], t[s + 2] = e[2];
    }

    return t;
  };
}();

function assert(e, t) {
  if (!e) throw new Error(t || "viewport-mercator-project: assertion failed.");
}

var PI = Math.PI,
    PI_4 = PI / 4,
    DEGREES_TO_RADIANS = PI / 180,
    RADIANS_TO_DEGREES = 180 / PI,
    TILE_SIZE = 512,
    EARTH_CIRCUMFERENCE = 4003e4,
    DEFAULT_ALTITUDE = 1.5;

function zoomToScale(e) {
  return Math.pow(2, e);
}

function lngLatToWorld(e, t) {
  var r = _slicedToArray(e, 2),
      a = r[0],
      n = r[1];

  assert(Number.isFinite(a) && Number.isFinite(t)), assert(Number.isFinite(n) && n >= -90 && n <= 90, "invalid latitude");
  var o = n * DEGREES_TO_RADIANS;
  return [(t *= TILE_SIZE) * (a * DEGREES_TO_RADIANS + PI) / (2 * PI), t * (PI - Math.log(Math.tan(PI_4 + .5 * o))) / (2 * PI)];
}

function worldToLngLat(e, t) {
  var r = _slicedToArray(e, 2),
      a = r[0],
      n = r[1],
      o = a / (t *= TILE_SIZE) * (2 * PI) - PI,
      i = 2 * (Math.atan(Math.exp(PI - n / t * (2 * PI))) - PI_4);

  return [o * RADIANS_TO_DEGREES, i * RADIANS_TO_DEGREES];
}

function getDistanceScales(e) {
  var t = e.latitude,
      r = e.longitude,
      a = e.zoom,
      n = e.scale,
      o = e.highPrecision,
      i = void 0 !== o && o;
  n = void 0 !== n ? n : zoomToScale(a), assert(Number.isFinite(t) && Number.isFinite(r) && Number.isFinite(n));

  var s = {},
      l = TILE_SIZE * n,
      u = Math.cos(t * DEGREES_TO_RADIANS),
      c = l / 360,
      _ = c / u,
      p = l / EARTH_CIRCUMFERENCE / u;

  if (s.pixelsPerMeter = [p, -p, p], s.metersPerPixel = [1 / p, -1 / p, 1 / p], s.pixelsPerDegree = [c, -_, p], s.degreesPerPixel = [1 / c, -1 / _, 1 / p], i) {
    var h = DEGREES_TO_RADIANS * Math.tan(t * DEGREES_TO_RADIANS) / u,
        f = c * h / 2,
        T = l / EARTH_CIRCUMFERENCE * h,
        d = T / _ * p;
    s.pixelsPerDegree2 = [0, -f, T], s.pixelsPerMeter2 = [d, 0, d];
  }

  return s;
}

function getViewMatrix(e) {
  var t = e.height,
      r = e.pitch,
      a = e.bearing,
      n = e.altitude,
      o = e.center,
      i = void 0 === o ? null : o,
      s = e.flipY,
      l = void 0 !== s && s,
      u = createMat4();
  return translate(u, u, [0, 0, -n]), scale$1(u, u, [1, 1, 1 / t]), rotateX(u, u, -r * DEGREES_TO_RADIANS), rotateZ(u, u, a * DEGREES_TO_RADIANS), l && scale$1(u, u, [1, -1, 1]), i && translate(u, u, negate$1([], i)), u;
}

function getProjectionParameters(e) {
  var t = e.width,
      r = e.height,
      a = e.altitude,
      n = void 0 === a ? DEFAULT_ALTITUDE : a,
      o = e.pitch,
      i = void 0 === o ? 0 : o,
      s = e.nearZMultiplier,
      l = void 0 === s ? 1 : s,
      u = e.farZMultiplier,
      c = void 0 === u ? 1 : u,
      _ = i * DEGREES_TO_RADIANS,
      p = Math.atan(.5 / n),
      h = Math.sin(p) * n / Math.sin(Math.PI / 2 - _ - p),
      f = Math.cos(Math.PI / 2 - _) * h + n;

  return {
    fov: 2 * Math.atan(r / 2 / n),
    aspect: t / r,
    focalDistance: n,
    near: l,
    far: f * c
  };
}

function getProjectionMatrix(e) {
  var t = e.width,
      r = e.height,
      a = e.pitch,
      n = getProjectionParameters({
    width: t,
    height: r,
    altitude: e.altitude,
    pitch: a,
    nearZMultiplier: e.nearZMultiplier,
    farZMultiplier: e.farZMultiplier
  });
  return perspective([], n.fov, n.aspect, n.near, n.far);
}

function worldToPixels(e, t) {
  var r = _slicedToArray(e, 3),
      a = r[0],
      n = r[1],
      o = r[2],
      i = void 0 === o ? 0 : o;

  return assert(Number.isFinite(a) && Number.isFinite(n) && Number.isFinite(i)), transformVector(t, [a, n, i, 1]);
}

function pixelsToWorld(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
      a = _slicedToArray(e, 3),
      n = a[0],
      o = a[1],
      i = a[2];

  if (assert(Number.isFinite(n) && Number.isFinite(o), "invalid pixel coordinate"), Number.isFinite(i)) return transformVector(t, [n, o, i, 1]);
  var s = transformVector(t, [n, o, 0, 1]),
      l = transformVector(t, [n, o, 1, 1]),
      u = s[2],
      c = l[2];
  return lerp([], s, l, u === c ? 0 : ((r || 0) - u) / (c - u));
}

var IDENTITY = createMat4(),
    Viewport = function () {
  function e() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        r = t.width,
        a = t.height,
        n = t.viewMatrix,
        o = void 0 === n ? IDENTITY : n,
        i = t.projectionMatrix,
        s = void 0 === i ? IDENTITY : i;
    _classCallCheck(this, e), this.width = r || 1, this.height = a || 1, this.scale = 1, this.pixelsPerMeter = 1, this.viewMatrix = o, this.projectionMatrix = s;
    var l = createMat4();
    multiply(l, l, this.projectionMatrix), multiply(l, l, this.viewMatrix), this.viewProjectionMatrix = l;
    var u = createMat4();
    scale$1(u, u, [this.width / 2, -this.height / 2, 1]), translate(u, u, [1, -1, 0]), multiply(u, u, this.viewProjectionMatrix);
    var c = invert(createMat4(), u);
    if (!c) throw new Error("Pixel project matrix not invertible");
    this.pixelProjectionMatrix = u, this.pixelUnprojectionMatrix = c, this.equals = this.equals.bind(this), this.project = this.project.bind(this), this.unproject = this.unproject.bind(this), this.projectPosition = this.projectPosition.bind(this), this.unprojectPosition = this.unprojectPosition.bind(this), this.projectFlat = this.projectFlat.bind(this), this.unprojectFlat = this.unprojectFlat.bind(this);
  }

  return _createClass(e, [{
    key: "equals",
    value: function value(t) {
      return t instanceof e && t.width === this.width && t.height === this.height && equals(t.projectionMatrix, this.projectionMatrix) && equals(t.viewMatrix, this.viewMatrix);
    }
  }, {
    key: "project",
    value: function value(e) {
      var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).topLeft,
          r = void 0 === t || t,
          a = worldToPixels(this.projectPosition(e), this.pixelProjectionMatrix),
          n = _slicedToArray(a, 2),
          o = n[0],
          i = n[1],
          s = r ? i : this.height - i;

      return 2 === e.length ? [o, s] : [o, s, a[2]];
    }
  }, {
    key: "unproject",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.topLeft,
          a = void 0 === r || r,
          n = t.targetZ,
          o = _slicedToArray(e, 3),
          i = o[0],
          s = o[1],
          l = o[2],
          u = a ? s : this.height - s,
          c = n && n * this.pixelsPerMeter,
          _ = pixelsToWorld([i, u, l], this.pixelUnprojectionMatrix, c),
          p = _slicedToArray(this.unprojectPosition(_), 3),
          h = p[0],
          f = p[1],
          T = p[2];

      return Number.isFinite(l) ? [h, f, T] : Number.isFinite(n) ? [h, f, n] : [h, f];
    }
  }, {
    key: "projectPosition",
    value: function value(e) {
      var t = _slicedToArray(this.projectFlat(e), 2);

      return [t[0], t[1], (e[2] || 0) * this.pixelsPerMeter];
    }
  }, {
    key: "unprojectPosition",
    value: function value(e) {
      var t = _slicedToArray(this.unprojectFlat(e), 2);

      return [t[0], t[1], (e[2] || 0) / this.pixelsPerMeter];
    }
  }, {
    key: "projectFlat",
    value: function value(e) {
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.scale;
      return e;
    }
  }, {
    key: "unprojectFlat",
    value: function value(e) {
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.scale;
      return e;
    }
  }]), e;
}();

function fitBounds(e) {
  var t = e.width,
      r = e.height,
      a = e.bounds,
      n = e.minExtent,
      o = void 0 === n ? 0 : n,
      i = e.maxZoom,
      s = void 0 === i ? 24 : i,
      l = e.padding,
      u = void 0 === l ? 0 : l,
      c = e.offset,
      _ = void 0 === c ? [0, 0] : c,
      p = _slicedToArray(a, 2),
      h = _slicedToArray(p[0], 2),
      f = h[0],
      T = h[1],
      d = _slicedToArray(p[1], 2),
      E = d[0],
      y = d[1];

  if (Number.isFinite(u)) {
    u = {
      top: u,
      bottom: u,
      left: u,
      right: u
    };
  } else assert(Number.isFinite(u.top) && Number.isFinite(u.bottom) && Number.isFinite(u.left) && Number.isFinite(u.right));

  var g = new WebMercatorViewport({
    width: t,
    height: r,
    longitude: 0,
    latitude: 0,
    zoom: 0
  }),
      v = g.project([f, y]),
      A = g.project([E, T]),
      b = [Math.max(Math.abs(A[0] - v[0]), o), Math.max(Math.abs(A[1] - v[1]), o)],
      m = [t - u.left - u.right - 2 * Math.abs(_[0]), r - u.top - u.bottom - 2 * Math.abs(_[1])];
  assert(m[0] > 0 && m[1] > 0);
  var S = m[0] / b[0],
      I = m[1] / b[1],
      L = (u.right - u.left) / 2 / S,
      M = (u.bottom - u.top) / 2 / I,
      P = [(A[0] + v[0]) / 2 + L, (A[1] + v[1]) / 2 + M],
      O = g.unproject(P),
      R = g.zoom + Math.log2(Math.abs(Math.min(S, I)));
  return {
    longitude: O[0],
    latitude: O[1],
    zoom: Math.min(R, s)
  };
}

var WebMercatorViewport = function (e) {
  function t() {
    var e,
        r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        a = r.width,
        n = r.height,
        o = r.latitude,
        i = void 0 === o ? 0 : o,
        s = r.longitude,
        l = void 0 === s ? 0 : s,
        u = r.zoom,
        c = void 0 === u ? 0 : u,
        _ = r.pitch,
        p = void 0 === _ ? 0 : _,
        h = r.bearing,
        f = void 0 === h ? 0 : h,
        T = r.altitude,
        d = void 0 === T ? 1.5 : T,
        E = r.nearZMultiplier,
        y = r.farZMultiplier;
    _classCallCheck(this, t), a = a || 1, n = n || 1;
    var g = zoomToScale(c);
    d = Math.max(.75, d);
    var v = lngLatToWorld([l, i], g);
    v[2] = 0;
    var A = getProjectionMatrix({
      width: a,
      height: n,
      pitch: p,
      bearing: f,
      altitude: d,
      nearZMultiplier: E || 1 / n,
      farZMultiplier: y || 1.01
    }),
        b = getViewMatrix({
      height: n,
      center: v,
      pitch: p,
      bearing: f,
      altitude: d,
      flipY: !0
    });
    return (e = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, {
      width: a,
      height: n,
      viewMatrix: b,
      projectionMatrix: A
    }))).latitude = i, e.longitude = l, e.zoom = c, e.pitch = p, e.bearing = f, e.altitude = d, e.scale = g, e.center = v, e.pixelsPerMeter = getDistanceScales(_assertThisInitialized(_assertThisInitialized(e))).pixelsPerMeter[2], Object.freeze(_assertThisInitialized(_assertThisInitialized(e))), e;
  }

  return _inherits(t, Viewport), _createClass(t, [{
    key: "projectFlat",
    value: function value(e) {
      return lngLatToWorld(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.scale);
    }
  }, {
    key: "unprojectFlat",
    value: function value(e) {
      return worldToLngLat(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.scale);
    }
  }, {
    key: "getMapCenterByLngLatPosition",
    value: function value(e) {
      var t = e.lngLat,
          r = pixelsToWorld(e.pos, this.pixelUnprojectionMatrix),
          a = add([], lngLatToWorld(t, this.scale), negate([], r));
      return worldToLngLat(add([], this.center, a), this.scale);
    }
  }, {
    key: "getLocationAtPoint",
    value: function value(e) {
      var t = e.lngLat,
          r = e.pos;
      return this.getMapCenterByLngLatPosition({
        lngLat: t,
        pos: r
      });
    }
  }, {
    key: "fitBounds",
    value: function value(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          a = this.width,
          n = this.height,
          o = fitBounds(Object.assign({
        width: a,
        height: n,
        bounds: e
      }, r));
      return new t({
        width: a,
        height: n,
        longitude: o.longitude,
        latitude: o.latitude,
        zoom: o.zoom
      });
    }
  }]), t;
}();

var VESSELS_MINIMUM_RADIUS_FACTOR = .25,
    VESSELS_MINIMUM_OPACITY = .5,
    VESSELS_HEATMAP_STYLE_ZOOM_THRESHOLD = 6,
    PLAYBACK_PRECISION = 864e5,
    TIMELINE_OVERALL_START_DATE = new Date(Date.UTC(2012, 0, 1)),
    TIMELINE_OVERALL_START_DATE_OFFSET = Math.floor(TIMELINE_OVERALL_START_DATE / PLAYBACK_PRECISION),
    getTimeAtPrecision = function getTimeAtPrecision(e) {
  return Math.floor(e / PLAYBACK_PRECISION);
};

var mapConvert = {
  latLonToWorldCoordinates: function latLonToWorldCoordinates(e, t) {
    return {
      worldX: (t + 180) / 360 * 256,
      worldY: (1 - Math.log(Math.tan(e * Math.PI / 180) + 1 / Math.cos(e * Math.PI / 180)) / Math.PI) / 2 * 256
    };
  },
  sigmaToRadius: function sigmaToRadius(e, t, r) {
    var a = t * Math.max(.8, 2 + Math.log(e * r));
    return a = Math.max(VESSELS_MINIMUM_RADIUS_FACTOR, a);
  },
  weightToOpacity: function weightToOpacity(e, t) {
    var r = 3 + Math.log(e * t);
    return r = Math.max(0, r), r = .1 + .2 * (r = 3 + Math.log(r)), r = Math.min(1, Math.max(VESSELS_MINIMUM_OPACITY, r));
  },
  getZoomFactorOpacity: function getZoomFactorOpacity(e) {
    return Math.pow(e - 1, 3.5) / 1e3;
  },
  getZoomFactorRadiusRenderingMode: function getZoomFactorRadiusRenderingMode(e) {
    return e < VESSELS_HEATMAP_STYLE_ZOOM_THRESHOLD ? .3 : .15;
  },
  getZoomFactorRadius: function getZoomFactorRadius(e) {
    return Math.pow(e - 1, 2.5);
  },
  getOffsetedTimeAtPrecision: function getOffsetedTimeAtPrecision(e) {
    return Math.max(0, getTimeAtPrecision(e) - TIMELINE_OVERALL_START_DATE_OFFSET);
  },
  getTimestampFromOffsetedtTimeAtPrecision: function getTimestampFromOffsetedtTimeAtPrecision(e) {
    return (TIMELINE_OVERALL_START_DATE_OFFSET + e) * PLAYBACK_PRECISION;
  }
};

function baseAssignValue(e, t, r) {
  "__proto__" == t && _defineProperty ? _defineProperty(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}

var _baseAssignValue = baseAssignValue,
    objectProto$a = Object.prototype,
    hasOwnProperty$8 = objectProto$a.hasOwnProperty;

function assignValue(e, t, r) {
  var a = e[t];
  hasOwnProperty$8.call(e, t) && eq_1(a, r) && (void 0 !== r || t in e) || _baseAssignValue(e, t, r);
}

var _assignValue = assignValue;

function copyObject(e, t, r, a) {
  var n = !r;
  r || (r = {});

  for (var o = -1, i = t.length; ++o < i;) {
    var s = t[o],
        l = a ? a(r[s], e[s], s, r, e) : void 0;
    void 0 === l && (l = e[s]), n ? _baseAssignValue(r, s, l) : _assignValue(r, s, l);
  }

  return r;
}

var _copyObject = copyObject;

function isIterateeCall(e, t, r) {
  if (!isObject(r)) return !1;
  var a = typeof t;
  return !!("number" == a ? isArrayLike_1(r) && _isIndex(t, r.length) : "string" == a && t in r) && eq_1(r[t], e);
}

var _isIterateeCall = isIterateeCall;

function createAssigner(e) {
  return _baseRest(function (t, r) {
    var a = -1,
        n = r.length,
        o = n > 1 ? r[n - 1] : void 0,
        i = n > 2 ? r[2] : void 0;

    for (o = e.length > 3 && "function" == typeof o ? (n--, o) : void 0, i && _isIterateeCall(r[0], r[1], i) && (o = n < 3 ? void 0 : o, n = 1), t = Object(t); ++a < n;) {
      var s = r[a];
      s && e(t, s, a, o);
    }

    return t;
  });
}

var _createAssigner = createAssigner;

function nativeKeysIn(e) {
  var t = [];
  if (null != e) for (var r in Object(e)) {
    t.push(r);
  }
  return t;
}

var _nativeKeysIn = nativeKeysIn,
    objectProto$b = Object.prototype,
    hasOwnProperty$9 = objectProto$b.hasOwnProperty;

function baseKeysIn(e) {
  if (!isObject(e)) return _nativeKeysIn(e);

  var t = _isPrototype(e),
      r = [];

  for (var a in e) {
    ("constructor" != a || !t && hasOwnProperty$9.call(e, a)) && r.push(a);
  }

  return r;
}

var _baseKeysIn = baseKeysIn;

function keysIn(e) {
  return isArrayLike_1(e) ? _arrayLikeKeys(e, !0) : _baseKeysIn(e);
}

var keysIn_1 = keysIn,
    assignInWith = _createAssigner(function (e, t, r, a) {
  _copyObject(t, keysIn_1(t), e, a);
}),
    assignInWith_1 = assignInWith,
    getPrototype = _overArg(Object.getPrototypeOf, Object),
    _getPrototype = getPrototype,
    objectTag$3 = "[object Object]",
    funcProto$2 = Function.prototype,
    objectProto$c = Object.prototype,
    funcToString$2 = funcProto$2.toString,
    hasOwnProperty$a = objectProto$c.hasOwnProperty,
    objectCtorString = funcToString$2.call(Object);

function isPlainObject(e) {
  if (!isObjectLike(e) || baseGetTag(e) != objectTag$3) return !1;

  var t = _getPrototype(e);

  if (null === t) return !0;
  var r = hasOwnProperty$a.call(t, "constructor") && t.constructor;
  return "function" == typeof r && r instanceof r && funcToString$2.call(r) == objectCtorString;
}

var isPlainObject_1 = isPlainObject,
    domExcTag = "[object DOMException]",
    errorTag$2 = "[object Error]";

function isError(e) {
  if (!isObjectLike(e)) return !1;
  var t = baseGetTag(e);
  return t == errorTag$2 || t == domExcTag || "string" == typeof e.message && "string" == typeof e.name && !isPlainObject_1(e);
}

var isError_1 = isError,
    attempt = _baseRest(function (e, t) {
  try {
    return _apply(e, void 0, t);
  } catch (e) {
    return isError_1(e) ? e : new Error(e);
  }
}),
    attempt_1 = attempt;

function baseValues(e, t) {
  return _arrayMap(t, function (t) {
    return e[t];
  });
}

var _baseValues = baseValues,
    objectProto$d = Object.prototype,
    hasOwnProperty$b = objectProto$d.hasOwnProperty;

function customDefaultsAssignIn(e, t, r, a) {
  return void 0 === e || eq_1(e, objectProto$d[r]) && !hasOwnProperty$b.call(a, r) ? t : e;
}

var _customDefaultsAssignIn = customDefaultsAssignIn,
    stringEscapes = {
  "\\": "\\",
  "'": "'",
  "\n": "n",
  "\r": "r",
  "\u2028": "u2028",
  "\u2029": "u2029"
};

function escapeStringChar(e) {
  return "\\" + stringEscapes[e];
}

var _escapeStringChar = escapeStringChar,
    reInterpolate = /<%=([\s\S]+?)%>/g,
    _reInterpolate = reInterpolate;

function basePropertyOf(e) {
  return function (t) {
    return null == e ? void 0 : e[t];
  };
}

var _basePropertyOf = basePropertyOf,
    htmlEscapes = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
},
    escapeHtmlChar = _basePropertyOf(htmlEscapes),
    _escapeHtmlChar = escapeHtmlChar,
    reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

function escape(e) {
  return (e = toString_1(e)) && reHasUnescapedHtml.test(e) ? e.replace(reUnescapedHtml, _escapeHtmlChar) : e;
}

var _escape = escape,
    reEscape = /<%-([\s\S]+?)%>/g,
    _reEscape = reEscape,
    reEvaluate = /<%([\s\S]+?)%>/g,
    _reEvaluate = reEvaluate,
    templateSettings = {
  escape: _reEscape,
  evaluate: _reEvaluate,
  interpolate: _reInterpolate,
  variable: "",
  imports: {
    _: {
      escape: _escape
    }
  }
},
    templateSettings_1 = templateSettings,
    reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
    reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
    reNoMatch = /($^)/,
    reUnescapedString = /['\n\r\u2028\u2029\\]/g,
    objectProto$e = Object.prototype,
    hasOwnProperty$c = objectProto$e.hasOwnProperty;

function template(e, t, r) {
  var a = templateSettings_1.imports._.templateSettings || templateSettings_1;
  r && _isIterateeCall(e, t, r) && (t = void 0), e = toString_1(e), t = assignInWith_1({}, t, a, _customDefaultsAssignIn);

  var n,
      o,
      i = assignInWith_1({}, t.imports, a.imports, _customDefaultsAssignIn),
      s = keys_1(i),
      l = _baseValues(i, s),
      u = 0,
      c = t.interpolate || reNoMatch,
      _ = "__p += '",
      p = RegExp((t.escape || reNoMatch).source + "|" + c.source + "|" + (c === _reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (t.evaluate || reNoMatch).source + "|$", "g"),
      h = hasOwnProperty$c.call(t, "sourceURL") ? "//# sourceURL=" + (t.sourceURL + "").replace(/[\r\n]/g, " ") + "\n" : "";

  e.replace(p, function (t, r, a, i, s, l) {
    return a || (a = i), _ += e.slice(u, l).replace(reUnescapedString, _escapeStringChar), r && (n = !0, _ += "' +\n__e(" + r + ") +\n'"), s && (o = !0, _ += "';\n" + s + ";\n__p += '"), a && (_ += "' +\n((__t = (" + a + ")) == null ? '' : __t) +\n'"), u = l + t.length, t;
  }), _ += "';\n";
  var f = hasOwnProperty$c.call(t, "variable") && t.variable;
  f || (_ = "with (obj) {\n" + _ + "\n}\n"), _ = (o ? _.replace(reEmptyStringLeading, "") : _).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;"), _ = "function(" + (f || "obj") + ") {\n" + (f ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (n ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + _ + "return __p\n}";
  var T = attempt_1(function () {
    return Function(s, h + "return " + _).apply(void 0, l);
  });
  if (T.source = _, isError_1(T)) throw T;
  return T;
}

var template_1 = template,
    buildEndpoint = function buildEndpoint(e, t) {
  return templateSettings_1.interpolate = /{{([\s\S]+?)}}/g, template_1(e)(t);
},
    byname = {
  Uint8: {
    size: Uint8Array.BYTES_PER_ELEMENT,
    array: "Float32Array",
    getter: "getUint8",
    setter: "setUint8"
  },
  Int8: {
    size: Int8Array.BYTES_PER_ELEMENT,
    array: "Float32Array",
    getter: "getUint8",
    setter: "setUint8"
  },
  Uint16: {
    size: Uint16Array.BYTES_PER_ELEMENT,
    array: "Float32Array",
    getter: "getUint16",
    setter: "setUint16"
  },
  Int16: {
    size: Int16Array.BYTES_PER_ELEMENT,
    array: "Float32Array",
    getter: "getInt16",
    setter: "setInt16"
  },
  Uint32: {
    size: Uint32Array.BYTES_PER_ELEMENT,
    array: "Float32Array",
    getter: "getUint32",
    setter: "setUint32"
  },
  Int32: {
    size: Int32Array.BYTES_PER_ELEMENT,
    array: "Float32Array",
    getter: "getInt32",
    setter: "setInt32"
  },
  Float32: {
    size: Float32Array.BYTES_PER_ELEMENT,
    array: "Float32Array",
    getter: "getFloat32",
    setter: "setFloat32"
  },
  Float64: {
    size: Float64Array.BYTES_PER_ELEMENT,
    array: "Float64Array",
    getter: "getFloat64",
    setter: "setFloat64"
  }
},
    writeStringToArrayBuffer = function writeStringToArrayBuffer(e, t, r, a, n) {
  null == r && (r = e.length), null == t && (t = 0), null == n && (n = t);

  for (var o = t; o < r; o++) {
    a[o - t + n] = 255 & e.charCodeAt(o);
  }
},
    stringToArrayBuffer = function stringToArrayBuffer(e, t, r) {
  null == r && (r = e.length), null == t && (t = 0);
  var a = new Uint8ClampedArray(r - t);
  return writeStringToArrayBuffer(e, t, r, a, 0), a.buffer;
},
    arrayBufferToString = function arrayBufferToString(e) {
  return String.fromCharCode.apply(null, new Uint8Array(e));
},
    pack = function pack(e, t, r) {
  var a = new ArrayBuffer(e.size);
  return new DataView(a)[e.setter](0, t, r), arrayBufferToString(a);
},
    Pack = {
  typemap: {
    byname: byname,
    byarray: {}
  },
  pack: pack,
  arrayBufferToString: arrayBufferToString,
  stringToArrayBuffer: stringToArrayBuffer,
  writeStringToArrayBuffer: writeStringToArrayBuffer
};

for (var name in Pack.typemap.byname) {
  var spec = Pack.typemap.byname[name];
  spec.name = name, Pack.typemap.byarray[spec.array] = spec;
}

var PelagosClient = function () {
  function PelagosClient() {
    _classCallCheck$1(this, PelagosClient), this.MAGIC_COOKIE = "tmtx";
  }

  return _createClass$1(PelagosClient, [{
    key: "obtainTile",
    value: function value(e, t) {
      return new Promise(function (r, a) {
        if (this.request = null, "undefined" == typeof XMLHttpRequest) throw "XMLHttpRequest is disabled";
        this.request = new XMLHttpRequest(), this.resolve = r, this.reject = a, this.request.open("GET", e, !0), t && this.request.setRequestHeader("Authorization", "Bearer ".concat(t)), this.request.responseType = "arraybuffer", this.request.onload = this.handleData.bind(this), this.request.onerror = this.handleData.bind(this), this.request.send(null);
      }.bind(this));
    }
  }, {
    key: "handleData",
    value: function handleData() {
      var self = this;

      if (this.request) {
        if (this.error) return !0;

        if (4 == this.request.readyState) {
          var success = 200 == this.request.status || this.isFileUri && 0 == this.request.status;
          if (!success) return void this.resolve(null);
        }

        if (this.request.response) {
          var length = this.request.response.byteLength,
              response = this.request.response,
              dataView = new DataView(response);

          if (!(length < 8)) {
            if (null == self.headerLen) {
              var cookie = Pack.arrayBufferToString(response.slice(0, 4));
              if (cookie != this.MAGIC_COOKIE) return void this.reject("Could not load " + this.url + " due to incorrect file format. Cookie: [" + this.cookie + "]");
              self.headerLen = dataView.getInt32(4, !0), self.offset = 8;
            }

            if (!(length < self.offset + self.headerLen)) {
              if (!self.headerIsLoaded) {
                self.header = JSON.parse(Pack.arrayBufferToString(response.slice(self.offset, self.offset + self.headerLen))), self.rowLen = 0, self.header.colsByName = {};

                for (var colidx = 0; colidx < self.header.cols.length; colidx++) {
                  var col = self.header.cols[colidx];
                  col.idx = colidx, self.header.colsByName[col.name] = col, col.typespec = Pack.typemap.byname[col.type], null != col.multiplier && null != col.min && (col.min = col.min * col.multiplier), null != col.offset && null != col.min && (col.min = col.min + col.offset), null != col.multiplier && null != col.max && (col.max = col.max * col.multiplier), null != col.offset && null != col.max && (col.max = col.max + col.offset), self.rowLen += col.typespec.size;
                }

                if (self.offset += self.headerLen, self.offset += (4 - self.headerLen % 4) % 4, self.headerIsLoaded = !0, "rowwise" != self.header.orientation && "columnwise" != self.header.orientation) return self.errorLoading({
                  orientation: self.header.orientation,
                  toString: function toString() {
                    return "Could not load " + this.url + " due to unsupported file orientation. Orientation: " + this.orientation + ". Supported orientations: rowwise, columnwise.";
                  }
                }), !0;
                if (!self.rowLen) return self.allLoaded(), !0;
              }

              if ("rowwise" == self.header.orientation) {
                for (var result = {}; self.offset + self.rowLen <= length; self.rowidx++) {
                  for (var row = {}, colidx = 0; colidx < self.header.cols.length; colidx++) {
                    var col = self.header.cols[colidx],
                        val = dataView[col.typespec.getter](self.offset, !0);
                    row[col.name] = val, self.offset += col.typespec.size;
                  }

                  result[col.name] = row;
                }

                self.rowidx == self.header.length && this.resolve(result);
              } else if ("columnwise" == self.header.orientation) {
                var colValues = null,
                    result = {};

                if (length >= self.offset + self.header.length * self.rowLen) {
                  for (var colidx = 0; colidx < self.header.cols.length; colidx++) {
                    var col = self.header.cols[colidx];
                    colValues = new (eval(col.typespec.array))(response.slice(self.offset, self.offset + col.typespec.size * self.header.length)), self.offset += self.header.length * col.typespec.size, result[col.name] = colValues;
                  }

                  return this.resolve(result), !0;
                }
              }
            }
          }
        }
      }
    }
  }]), PelagosClient;
}(),
    getTemporalTileURLs = function getTemporalTileURLs(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      a = [];
  return (t || [null]).forEach(function (t, n) {
    var o = {};
    null !== t && !0 !== r.temporalExtentsLess && (o.startTimeISO = new Date(t[0]).toISOString(), o.endTimeISO = new Date(t[1]).toISOString()), r.tileCoordinates && (o.x = r.tileCoordinates.x, o.y = r.tileCoordinates.y, o.z = r.tileCoordinates.zoom);
    var i = buildEndpoint(e, o);
    (!0 === r.temporalExtentsLess || !r.temporalExtentsIndices || r.temporalExtentsIndices.indexOf(n) > -1) && a.push(i);
  }), a;
},
    getTilePromises = function getTilePromises(e, t, r) {
  for (var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, n = [], o = getTemporalTileURLs(e, r, a), i = 0, s = o.length; i < s; i++) {
    n.push(new PelagosClient().obtainTile(o[i], t));
  }

  return n;
},
    getCleanVectorArrays = function getCleanVectorArrays(e) {
  return e.filter(function (e) {
    return null !== e;
  });
},
    groupData = function groupData(e, t) {
  var r,
      a = {},
      n = sumBy_1(e, function (e) {
    return e.longitude.length;
  }),
      o = t.filter(function (t) {
    return !e[0] || void 0 !== e[0][t] || (console.warn("column ".concat(t, " is present in layerHeader.colsByName but not in tile data")), !1);
  });
  o.forEach(function (e) {
    a[e] = new Float32Array(n);
  });

  for (var i = 0, s = function s(e) {
    a[e].set(r[e], i);
  }, l = 0, u = e.length; l < u; l++) {
    r = e[l], o.forEach(s), i += r.longitude.length;
  }

  return a;
},
    getTilePlaybackData = function getTilePlaybackData(e, t, r, a) {
  var n = void 0 === a ? [] : a,
      o = r.zoom,
      i = mapConvert.getZoomFactorRadius(o),
      s = mapConvert.getZoomFactorRadiusRenderingMode(o),
      l = mapConvert.getZoomFactorOpacity(o),
      u = {},
      c = Object.keys(t);
  c.forEach(function (e) {
    u[e] = !0;
  });

  var _ = [].concat(c);

  !0 === u.sigma && _.push("radius"), !0 === u.weight && _.push("opacity"), !0 === u.longitude && (_.push("worldX"), _.push("worldY")), !0 === u.id && _.push("series"), ["latitude", "longitude", "datetime"].forEach(function (e) {
    void 0 !== t[e] && !0 !== t[e].hidden || pull_1(_, e);
  }), pull_1(_, "sigma", "weight"), _ = uniq_1(_);

  for (var p = e.latitude.length, h = {}, f = [], T = function T(t, r) {
    var a = {};
    c.forEach(function (r) {
      a[r] = e[r][t];
    });

    var n = u.timeIndex ? a.timeIndex : mapConvert.getOffsetedTimeAtPrecision(a.datetime),
        o = lngLatToWorld([a.longitude, a.latitude], 1),
        p = _slicedToArray$1(o, 2),
        T = p[0],
        d = p[1];

    if (a.worldX = T, a.worldY = d, u.sigma && (a.radius = mapConvert.sigmaToRadius(a.sigma, s, i)), u.weight && (a.opacity = mapConvert.weightToOpacity(a.weight, l)), u.id && (a.series = a.id), !h[n]) {
      f.push(n);
      var E = {};
      return _.forEach(function (e) {
        E[e] = [a[e]];
      }), h[n] = E, "continue";
    }

    var y = h[n];

    _.forEach(function (e) {
      y[e].push(a[e]);
    });
  }, d = 0, E = p; d < E; d++) {
    T(d);
  }

  return f.forEach(function (e) {
    n[e] = h[e];
  }), n;
},
    vesselSatisfiesFilters = function vesselSatisfiesFilters(e, t, r) {
  return Object.keys(r).every(function (a) {
    return void 0 !== e[a] && r[a].indexOf(e[a][t]) > -1;
  });
},
    vesselSatisfiesAllFilters = function vesselSatisfiesAllFilters(e, t, r) {
  return r.filter(function (e) {
    return !0 !== e.pass;
  }).some(function (r) {
    return vesselSatisfiesFilters(e, t, r.filterValues);
  });
},
    selectVesselsAt = function selectVesselsAt(e, t, r, a, n) {
  for (var o = [], i = t.worldX, s = t.worldY, l = t.toleranceRadiusInWorldUnits, u = function u(t) {
    var r = e[t];
    if (void 0 === r) return "continue";

    for (var a = function a(e) {
      var a = r.worldX[e],
          u = r.worldY[e];

      if ((!n.length || vesselSatisfiesAllFilters(r, e, n)) && a >= i - l && a <= i + l && u >= s - l && u <= s + l) {
        var c = {};
        Object.keys(r).forEach(function (t) {
          c[t] = r[t][e];
        }), c.timeIndex = t, o.push(c);
      }
    }, u = 0; u < r.worldX.length; u++) {
      a(u);
    }
  }, c = r; c < a; c++) {
    u(c);
  }

  return o;
},
    d2r = Math.PI / 180,
    r2d = 180 / Math.PI;

function tileToBBOX(e) {
  var t = tile2lon(e[0] + 1, e[2]);
  return [tile2lon(e[0], e[2]), tile2lat(e[1] + 1, e[2]), t, tile2lat(e[1], e[2])];
}

function tileToGeoJSON(e) {
  var t = tileToBBOX(e);
  return {
    type: "Polygon",
    coordinates: [[[t[0], t[1]], [t[0], t[3]], [t[2], t[3]], [t[2], t[1]], [t[0], t[1]]]]
  };
}

function tile2lon(e, t) {
  return e / Math.pow(2, t) * 360 - 180;
}

function tile2lat(e, t) {
  var r = Math.PI - 2 * Math.PI * e / Math.pow(2, t);
  return r2d * Math.atan(.5 * (Math.exp(r) - Math.exp(-r)));
}

function pointToTile(e, t, r) {
  var a = pointToTileFraction(e, t, r);
  return a[0] = Math.floor(a[0]), a[1] = Math.floor(a[1]), a;
}

function getChildren(e) {
  return [[2 * e[0], 2 * e[1], e[2] + 1], [2 * e[0] + 1, 2 * e[1], e[2] + 1], [2 * e[0] + 1, 2 * e[1] + 1, e[2] + 1], [2 * e[0], 2 * e[1] + 1, e[2] + 1]];
}

function getParent(e) {
  return e[0] % 2 == 0 && e[1] % 2 == 0 ? [e[0] / 2, e[1] / 2, e[2] - 1] : e[0] % 2 == 0 && !e[1] % 2 == 0 ? [e[0] / 2, (e[1] - 1) / 2, e[2] - 1] : !e[0] % 2 == 0 && e[1] % 2 == 0 ? [(e[0] - 1) / 2, e[1] / 2, e[2] - 1] : [(e[0] - 1) / 2, (e[1] - 1) / 2, e[2] - 1];
}

function getSiblings(e) {
  return getChildren(getParent(e));
}

function hasSiblings(e, t) {
  for (var r = getSiblings(e), a = 0; a < r.length; a++) {
    if (!hasTile(t, r[a])) return !1;
  }

  return !0;
}

function hasTile(e, t) {
  for (var r = 0; r < e.length; r++) {
    if (tilesEqual(e[r], t)) return !0;
  }

  return !1;
}

function tilesEqual(e, t) {
  return e[0] === t[0] && e[1] === t[1] && e[2] === t[2];
}

function tileToQuadkey(e) {
  for (var t = "", r = e[2]; r > 0; r--) {
    var a = 0,
        n = 1 << r - 1;
    0 != (e[0] & n) && a++, 0 != (e[1] & n) && (a += 2), t += a.toString();
  }

  return t;
}

function quadkeyToTile(e) {
  for (var t = 0, r = 0, a = e.length, n = a; n > 0; n--) {
    var o = 1 << n - 1,
        i = +e[a - n];
    1 === i && (t |= o), 2 === i && (r |= o), 3 === i && (t |= o, r |= o);
  }

  return [t, r, a];
}

function bboxToTile(e) {
  var t = pointToTile(e[0], e[1], 32),
      r = pointToTile(e[2], e[3], 32),
      a = [t[0], t[1], r[0], r[1]],
      n = getBboxZoom(a);
  return 0 === n ? [0, 0, 0] : [a[0] >>> 32 - n, a[1] >>> 32 - n, n];
}

function getBboxZoom(e) {
  for (var t = 0; t < 28; t++) {
    var r = 1 << 32 - (t + 1);
    if ((e[0] & r) != (e[2] & r) || (e[1] & r) != (e[3] & r)) return t;
  }

  return 28;
}

function pointToTileFraction(e, t, r) {
  var a = Math.sin(t * d2r),
      n = Math.pow(2, r);
  return [n * (e / 360 + .5), n * (.5 - .25 * Math.log((1 + a) / (1 - a)) / Math.PI), r];
}

var tilebelt = {
  tileToGeoJSON: tileToGeoJSON,
  tileToBBOX: tileToBBOX,
  getChildren: getChildren,
  getParent: getParent,
  getSiblings: getSiblings,
  hasTile: hasTile,
  hasSiblings: hasSiblings,
  tilesEqual: tilesEqual,
  tileToQuadkey: tileToQuadkey,
  quadkeyToTile: quadkeyToTile,
  pointToTile: pointToTile,
  bboxToTile: bboxToTile,
  pointToTileFraction: pointToTileFraction
},
    geojson = function geojson(e, t) {
  return {
    type: "FeatureCollection",
    features: getTiles(e, t).map(tileToFeature)
  };
};

function tileToFeature(e) {
  return {
    type: "Feature",
    geometry: tilebelt.tileToGeoJSON(e),
    properties: {}
  };
}

var tiles = getTiles,
    indexes = function indexes(e, t) {
  return getTiles(e, t).map(tilebelt.tileToQuadkey);
};

function getTiles(e, t) {
  var r,
      a,
      n = e.coordinates,
      o = t.max_zoom,
      i = {},
      s = [];
  if ("Point" === e.type) return [tilebelt.pointToTile(n[0], n[1], o)];
  if ("MultiPoint" === e.type) for (r = 0; r < n.length; r++) {
    i[toID((a = tilebelt.pointToTile(n[r][0], n[r][1], o))[0], a[1], a[2])] = !0;
  } else if ("LineString" === e.type) lineCover(i, n, o);else if ("MultiLineString" === e.type) for (r = 0; r < n.length; r++) {
    lineCover(i, n[r], o);
  } else if ("Polygon" === e.type) polygonCover(i, s, n, o);else {
    if ("MultiPolygon" !== e.type) throw new Error("Geometry type not implemented");

    for (r = 0; r < n.length; r++) {
      polygonCover(i, s, n[r], o);
    }
  }

  if (t.min_zoom !== o) {
    var l = s.length;

    for (appendHashTiles(i, s), r = 0; r < l; r++) {
      var u = s[r];
      i[toID(u[0], u[1], u[2])] = !0;
    }

    return mergeTiles(i, s, t);
  }

  return appendHashTiles(i, s), s;
}

function mergeTiles(e, t, r) {
  for (var a = [], n = r.max_zoom; n > r.min_zoom; n--) {
    for (var o = {}, i = [], s = 0; s < t.length; s++) {
      var l = t[s];

      if (l[0] % 2 == 0 && l[1] % 2 == 0) {
        var u = toID(l[0] + 1, l[1], n),
            c = toID(l[0], l[1] + 1, n),
            _ = toID(l[0] + 1, l[1] + 1, n);

        if (e[u] && e[c] && e[_]) {
          e[toID(l[0], l[1], l[2])] = !1, e[u] = !1, e[c] = !1, e[_] = !1;
          var p = [l[0] / 2, l[1] / 2, n - 1];
          n - 1 === r.min_zoom ? a.push(p) : (o[toID(l[0] / 2, l[1] / 2, n - 1)] = !0, i.push(p));
        }
      }
    }

    for (s = 0; s < t.length; s++) {
      e[toID((l = t[s])[0], l[1], l[2])] && a.push(l);
    }

    e = o, t = i;
  }

  return a;
}

function polygonCover(e, t, r, a) {
  for (var n = [], o = 0; o < r.length; o++) {
    var i = [];
    lineCover(e, r[o], a, i);

    for (var s = 0, l = i.length, u = l - 1; s < l; u = s++) {
      var c = (s + 1) % l,
          _ = i[s][1];
      (_ > i[u][1] || _ > i[c][1]) && (_ < i[u][1] || _ < i[c][1]) && _ !== i[c][1] && n.push(i[s]);
    }
  }

  for (n.sort(compareTiles), o = 0; o < n.length; o += 2) {
    _ = n[o][1];

    for (var p = n[o][0] + 1; p < n[o + 1][0]; p++) {
      e[toID(p, _, a)] || t.push([p, _, a]);
    }
  }
}

function compareTiles(e, t) {
  return e[1] - t[1] || e[0] - t[0];
}

function lineCover(e, t, r, a) {
  for (var n, o, i = 0; i < t.length - 1; i++) {
    var s = tilebelt.pointToTileFraction(t[i][0], t[i][1], r),
        l = tilebelt.pointToTileFraction(t[i + 1][0], t[i + 1][1], r),
        u = s[0],
        c = s[1],
        _ = l[0] - u,
        p = l[1] - c;

    if (0 !== p || 0 !== _) {
      var h = _ > 0 ? 1 : -1,
          f = p > 0 ? 1 : -1,
          T = Math.floor(u),
          d = Math.floor(c),
          E = 0 === _ ? 1 / 0 : Math.abs(((_ > 0 ? 1 : 0) + T - u) / _),
          y = 0 === p ? 1 / 0 : Math.abs(((p > 0 ? 1 : 0) + d - c) / p),
          g = Math.abs(h / _),
          v = Math.abs(f / p);

      for (T === n && d === o || (e[toID(T, d, r)] = !0, a && d !== o && a.push([T, d]), n = T, o = d); E < 1 || y < 1;) {
        E < y ? (E += g, T += h) : (y += v, d += f), e[toID(T, d, r)] = !0, a && d !== o && a.push([T, d]), n = T, o = d;
      }
    }
  }

  a && d === a[0][1] && a.pop();
}

function appendHashTiles(e, t) {
  for (var r = Object.keys(e), a = 0; a < r.length; a++) {
    t.push(fromID(+r[a]));
  }
}

function toID(e, t, r) {
  return 32 * (2 * (1 << r) * t + e) + r;
}

function fromID(e) {
  var t = e % 32,
      r = 2 * (1 << t),
      a = (e - t) / 32,
      n = a % r;
  return [n, (a - n) / r % r, t];
}

var tileCover = {
  geojson: geojson,
  tiles: tiles,
  indexes: indexes
},
    SET_CURRENTLY_VISIBLE_TILES = "SET_CURRENTLY_VISIBLE_TILES",
    SET_CURRENTLY_LOADED_TILES = "SET_CURRENTLY_LOADED_TILES",
    SET_CURRENTLY_SWAPPED_TILE_UIDS = "SET_CURRENTLY_SWAPPED_TILE_UIDS",
    MARK_TILES_UIDS_AS_LOADED = "MARK_TILES_UIDS_AS_LOADED",
    RELEASE_MARKED_TILES_UIDS = "RELEASE_MARKED_TILES_UIDS",
    getTilecoverLimits = function getTilecoverLimits(e) {
  var t = Math.ceil(e + TILES_LOAD_ZOOM_OFFSET),
      r = !0;
  return t > ACTIVITY_LAYERS_MAX_ZOOM_LEVEL_TILE_LOADING && (t = ACTIVITY_LAYERS_MAX_ZOOM_LEVEL_TILE_LOADING, r = !1), {
    min_zoom: t,
    max_zoom: t,
    tilesAvailable: r
  };
},
    flushToReleaseTiles = function flushToReleaseTiles() {
  return function (e, t) {
    var r = t();

    if (!r.map.heatmapTiles.currentToLoadTileUids.length) {
      var a = r.map.heatmapTiles.currentToReleaseTileUids;
      e(releaseTiles(a)), e({
        type: RELEASE_MARKED_TILES_UIDS
      });
    }
  };
},
    markTileAsLoaded = function markTileAsLoaded(e) {
  return function (t) {
    t({
      type: MARK_TILES_UIDS_AS_LOADED,
      payload: e
    }), t(flushToReleaseTiles());
  };
},
    flushTileState = function flushTileState() {
  var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
  return function (t, r) {
    var a = r(),
        n = a.map.heatmapTiles.currentVisibleTiles,
        o = [],
        i = [];
    if (!0 === e) o = n;else {
      var s = a.map.heatmapTiles.currentLoadedTiles;
      n.forEach(function (e) {
        void 0 === s.find(function (t) {
          return t.uid === e.uid;
        }) && o.push(e);
      }), s.forEach(function (e) {
        void 0 === n.find(function (t) {
          return t.uid === e.uid;
        }) && i.push(e.uid);
      });
    }
    var l = o.map(function (e) {
      return e.uid;
    });
    o.forEach(function (e) {
      t(getTile(e));
    }), t({
      type: SET_CURRENTLY_LOADED_TILES,
      payload: n
    }), t({
      type: SET_CURRENTLY_SWAPPED_TILE_UIDS,
      payload: {
        tilesToLoadUids: l,
        tilesToReleaseUids: i
      }
    }), t(updateLoadedTiles()), t(flushToReleaseTiles());
  };
},
    _debouncedFlushState = function _debouncedFlushState(e) {
  e(flushTileState());
},
    debouncedFlushState = debounce(_debouncedFlushState, 500),
    updateHeatmapTilesFromViewport = function updateHeatmapTilesFromViewport() {
  var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
  return function (t, r) {
    var a = r().map.viewport,
        n = a.viewport;

    if (n.width && n.height && null === a.currentTransition) {
      var o = new WebMercatorViewport(n),
          i = [o.unproject([0, 0]), o.unproject([n.width, n.height])],
          s = i[0],
          l = i[1],
          u = [s[0], l[1], l[0], s[1]],
          c = u[0],
          _ = u[1],
          p = u[2],
          h = u[3],
          f = [],
          T = getTilecoverLimits(n.zoom);

      if (!1 !== T.tilesAvailable || !0 === e) {
        if (p > 180 || c < -180) {
          var d = p > 180 ? c : c + 360,
              E = p > 180 ? p - 360 : p;
          f.push([[[d, h], [179.999, h], [179.999, _], [d, _], [d, h]]]), f.push([[[-180, h], [E, h], [E, _], [-180, _], [-180, h]]]);
        } else f.push([[[c, h], [p, h], [p, _], [c, _], [c, h]]]);

        var y = {
          type: "MultiPolygon",
          coordinates: f
        },
            g = tileCover.tiles(y, T),
            v = tileCover.indexes(y, T),
            A = [];
        g.forEach(function (e, t) {
          var r = v[t];
          e[2] >= 2 && A.push({
            tileCoordinates: {
              x: e[0],
              y: e[1],
              zoom: e[2]
            },
            uid: r
          });
        }), t({
          type: SET_CURRENTLY_VISIBLE_TILES,
          payload: A
        }), !1 === (a.prevZoom !== n.zoom) ? t(flushTileState(e)) : debouncedFlushState(t);
      }
    }
  };
},
    queryHeatmapVessels = function queryHeatmapVessels(e, t) {
  return function (r, a) {
    var n = {
      type: "Point",
      coordinates: [e.longitude, e.latitude]
    },
        o = a().map.viewport.viewport.zoom,
        i = [o, o - 1, o + 1].map(function (e) {
      return getTilecoverLimits(e);
    }).map(function (e) {
      return tileCover.indexes(n, e);
    }).map(function (e) {
      return e[0];
    });
    r(highlightVesselFromHeatmap(_objectSpread2({}, e, {
      uids: i
    }), t));
  };
},
    ADD_HEATMAP_LAYER = "ADD_HEATMAP_LAYER",
    UPDATE_HEATMAP_LAYER_STYLE = "UPDATE_HEATMAP_LAYER_STYLE",
    ADD_REFERENCE_TILE = "ADD_REFERENCE_TILE",
    HIGHLIGHT_VESSELS = "HIGHLIGHT_VESSELS",
    INIT_HEATMAP_LAYERS = "INIT_HEATMAP_LAYERS",
    REMOVE_HEATMAP_LAYER = "REMOVE_HEATMAP_LAYER",
    UPDATE_HEATMAP_LAYER_TEMPORAL_EXTENTS_LOADED_INDICES = "UPDATE_HEATMAP_LAYER_TEMPORAL_EXTENTS_LOADED_INDICES",
    UPDATE_HEATMAP_TILE = "UPDATE_HEATMAP_TILE",
    RELEASE_HEATMAP_TILES = "RELEASE_HEATMAP_TILES",
    UPDATE_LOADED_TILES = "UPDATE_LOADED_TILES",
    HIGHLIGHT_CLICKED_VESSEL = "HIGHLIGHT_CLICKED_VESSEL",
    CLEAR_HIGHLIGHT_CLICKED_VESSEL = "CLEAR_HIGHLIGHT_CLICKED_VESSEL";

function getTemporalExtentsVisibleIndices(e, t) {
  var r = e[0].getTime(),
      a = e[1].getTime(),
      n = [];
  return t.forEach(function (e, t) {
    var o = e[0];
    e[1] >= r && o <= a && n.push(t);
  }), n;
}

function loadLayerTile(e, t, r, a, n) {
  var o = n.url,
      i = n.temporalExtents,
      s = n.temporalExtentsLess;
  if (void 0 === o) throw new Error("URL/endpoints object is not available on this tilesets header");
  var l = getTilePromises(o, r, i, {
    tileCoordinates: t,
    temporalExtentsIndices: a,
    temporalExtentsLess: s
  }),
      u = Promise.all(l);
  return new Promise(function (t) {
    u.then(function (r) {
      t({
        loadedLayerId: e,
        rawTileData: r
      });
    });
  });
}

function parseLayerTile(e, t, r, a) {
  var n,
      o = getCleanVectorArrays(e);
  return n = groupData(o, Object.keys(t)), 0 === Object.keys(n).length ? [] : getTilePlaybackData(n, t, r, a);
}

function getTiles$1(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
  return function (a, n) {
    var o = n(),
        i = startLoader(a, o, e.join("-")),
        s = o.map.module.token,
        l = o.map.heatmap.heatmapLayers,
        u = {};
    e.forEach(function (e) {
      u[e] = _toConsumableArray(l[e].tiles);
    });
    var c = [];
    e.forEach(function (e) {
      var n = l[e].header,
          o = _objectSpread2({}, n),
          i = o.temporalExtents,
          _ = o.temporalExtentsLess,
          p = o.colsByName,
          h = n.endpoints.tiles;

      t.forEach(function (t) {
        var n = u[e].find(function (e) {
          return e.uid === t.uid;
        });
        n || (n = {
          uid: t.uid,
          temporalExtentsIndicesLoaded: []
        }, u[e].push(n));
        var o = void 0 === r ? l[e].visibleTemporalExtentsIndices : r[e],
            f = difference_1(o, n.temporalExtentsIndicesLoaded),
            T = loadLayerTile(e, t.tileCoordinates, s, f, {
          url: h,
          temporalExtents: i,
          temporalExtentsLess: _
        });
        c.push(T), T.then(function (e) {
          var r = e.loadedLayerId,
              o = e.rawTileData;
          n.temporalExtentsIndicesLoaded = uniq_1(n.temporalExtentsIndicesLoaded.concat(f)), n.data = parseLayerTile(o, p, t.tileCoordinates, n.data), a({
            type: UPDATE_HEATMAP_TILE,
            payload: {
              layerId: r,
              tile: n
            }
          });
        });
      });
    }), Promise.all(c).then(function () {
      a(completeLoader(i)), a(markTileAsLoaded(t.map(function (e) {
        return e.uid;
      })));
    });
  };
}

function getTile(e) {
  return function (t, r) {
    t({
      type: ADD_REFERENCE_TILE,
      payload: e
    });
    var a = r().map.heatmap.heatmapLayers,
        n = Object.keys(a).filter(function (e) {
      return !0 === a[e].visible;
    });
    n.length && t(getTiles$1(n, [e]));
  };
}

var releaseTiles = function releaseTiles(e) {
  return {
    type: RELEASE_HEATMAP_TILES,
    payload: e
  };
},
    updateLoadedTiles = function updateLoadedTiles() {
  return {
    type: UPDATE_LOADED_TILES
  };
};

function loadAllTilesForLayer(e) {
  return function (t, r) {
    var a = r().map.heatmap.referenceTiles;
    t(getTiles$1([e], a));
  };
}

var addHeatmapLayer = function addHeatmapLayer(e, t) {
  return function (r) {
    var a = e.header.temporalExtents;
    r({
      type: ADD_HEATMAP_LAYER,
      payload: _objectSpread2({}, e, {
        visibleTemporalExtentsIndices: getTemporalExtentsVisibleIndices(t, a)
      })
    }), !0 === e.visible && r(loadAllTilesForLayer(e.id));
  };
},
    removeHeatmapLayer = function removeHeatmapLayer(e) {
  return function (t) {
    t({
      type: REMOVE_HEATMAP_LAYER,
      payload: {
        id: e
      }
    });
  };
};

function updateLayerLoadTemporalExtents(e) {
  return function (t, r) {
    var a = r(),
        n = a.map.heatmap.heatmapLayers,
        o = {};
    Object.keys(n).forEach(function (r) {
      var a = n[r],
          i = a.header.temporalExtents,
          s = a.visibleTemporalExtentsIndices,
          l = getTemporalExtentsVisibleIndices(e, i),
          u = difference_1(l, s),
          c = difference_1(s, l);
      (u.length || c.length) && t({
        type: UPDATE_HEATMAP_LAYER_TEMPORAL_EXTENTS_LOADED_INDICES,
        payload: {
          layerId: r,
          newVisibleTemporalExtentsIndices: l,
          indicesRemoved: c
        }
      }), u.length && (o[r] = u);
    });
    var i = Object.keys(o);
    i.length && t(getTiles$1(i, a.map.heatmap.referenceTiles, o));
  };
}

var _queryHeatmap = function _queryHeatmap(e, t, r) {
  var a = e.map.heatmap.heatmapLayers,
      n = r[0],
      o = r[1],
      i = [];
  Object.keys(a).forEach(function (e) {
    var r = a[e];

    if (!0 === r.visible) {
      var s = t.uids.map(function (e) {
        return r.tiles.find(function (t) {
          return t.uid === e;
        });
      }).filter(function (e) {
        return void 0 !== e && void 0 !== e.data;
      }),
          l = r.filters;

      if (s.length) {
        var u = s[0];
        i.push({
          layer: r,
          vessels: selectVesselsAt(u.data, t, n, o, l)
        });
      }
    }
  });

  var s,
      l,
      u,
      c,
      _,
      p = i.filter(function (e) {
    return e.vessels.length > 0;
  });

  if (0 === p.length) u = !0;else if (p.length > 1) s = !0;else {
    var h = (c = p[0]).vessels;
    if (0 === h.length) u = !0;else h.filter(function (e) {
      return e.id < 0;
    }).length ? s = !0 : l = (_ = uniqBy_1(h, function (e) {
      return e.series;
    })).length > 1;
  }
  return {
    isEmpty: u,
    isCluster: s,
    isMouseCluster: l,
    foundVessels: _,
    layer: void 0 === c ? {} : c.layer
  };
};

function clearHighlightedVessels() {
  return {
    type: HIGHLIGHT_VESSELS,
    payload: {
      isEmpty: !0,
      clickableCluster: !1
    }
  };
}

function highlightVesselFromHeatmap(e, t) {
  return function (r, a) {
    var n = a(),
        o = _queryHeatmap(n, e, t),
        i = o.layer,
        s = o.isEmpty,
        l = o.isCluster,
        u = o.isMouseCluster,
        c = o.foundVessels;

    if (!0 === l || void 0 !== i.id || n.map.heatmap.highlightedVessels.layerId !== i.id) {
      var _ = void 0 === i ? null : {
        id: i.id,
        tilesetId: i.tilesetId,
        subtype: i.subtype,
        header: i.header
      };

      r({
        type: HIGHLIGHT_VESSELS,
        payload: {
          layer: _,
          isEmpty: s,
          clickableCluster: !0 === l || !0 === u,
          highlightableCluster: !0 !== l,
          foundVessels: c
        }
      });
    } else r(clearHighlightedVessels());
  };
}

var clearHighlightedClickedVessel = function clearHighlightedClickedVessel() {
  return {
    type: CLEAR_HIGHLIGHT_CLICKED_VESSEL
  };
},
    updateHeatmapLayers = function updateHeatmapLayers(e, t) {
  return function (r, a) {
    if (null !== e) {
      var n = a().map.heatmap.heatmapLayers;
      e.forEach(function (e) {
        var a = e.id,
            o = n[a];
        void 0 === o ? r(addHeatmapLayer(e, t)) : (o.visible !== e.visible && !0 === e.visible && r(loadAllTilesForLayer(a)), o.visible === e.visible && o.hue === e.hue && o.opacity === e.opacity && o.filters === e.filters && o.interactive === e.interactive || r({
          type: UPDATE_HEATMAP_LAYER_STYLE,
          payload: {
            id: e.id,
            visible: e.visible,
            hue: e.hue,
            opacity: e.opacity,
            filters: e.filters,
            interactive: e.interactive
          }
        }));
      }), Object.keys(n).forEach(function (t) {
        e.find(function (e) {
          return e.id === t;
        }) || r(removeHeatmapLayer(t));
      });
    } else console.warn("New layers in updateHeatmapLayers can't be null");
  };
},
    SET_BOUNDS = "SET_BOUNDS",
    SET_VIEWPORT = "SET_VIEWPORT",
    UPDATE_VIEWPORT = "UPDATE_VIEWPORT",
    SET_ZOOM_INCREMENT = "SET_ZOOM_INCREMENT",
    SET_MOUSE_LAT_LONG = "SET_MOUSE_LAT_LONG",
    TRANSITION_END = "TRANSITION_END",
    SET_NATIVE_VIEWPORT = "SET_NATIVE_VIEWPORT",
    setBounds = function setBounds(e) {
  return {
    type: SET_BOUNDS,
    payload: e
  };
},
    setViewport = function setViewport(e, t) {
  return function (r) {
    r({
      type: SET_VIEWPORT,
      payload: e
    }), r(updateHeatmapTilesFromViewport()), r(onViewportChange(t));
  };
},
    updateViewport = function updateViewport(e) {
  return function (t) {
    t({
      type: UPDATE_VIEWPORT,
      payload: e
    }), t(updateHeatmapTilesFromViewport());
  };
},
    transitionTo = function transitionTo(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
      a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
  return function (n) {
    n({
      type: SET_ZOOM_INCREMENT,
      payload: {
        increment: e,
        latitude: t,
        longitude: r,
        zoom: a
      }
    }), n(updateHeatmapTilesFromViewport()), n(onViewportChange());
  };
},
    transitionToZoom = function transitionToZoom(e) {
  return function (t) {
    t(transitionTo(null, e.center[0], e.center[1], e.zoom));
  };
},
    transitionEnd = function transitionEnd() {
  return function (e) {
    e({
      type: TRANSITION_END
    }), e(updateHeatmapTilesFromViewport()), e(onViewportChange());
  };
},
    zoomIntoVesselCenter = function zoomIntoVesselCenter(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
  return function (a) {
    a(transitionTo(CLUSTER_CLICK_ZOOM_INCREMENT, e, t, r));
  };
},
    fitToBounds = function fitToBounds(e) {
  return function (t, r) {
    var a = r(),
        n = fitBounds({
      bounds: [[e.minLng, e.minLat], [e.maxLng, e.maxLat]],
      width: a.map.viewport.viewport.width,
      height: a.map.viewport.viewport.height,
      padding: 50
    });
    t(transitionTo(null, n.latitude, n.longitude, n.zoom));
  };
},
    exportNativeViewport = function exportNativeViewport(e) {
  return function (t) {
    var r = [0, 0],
        a = [e.width, e.height],
        n = pixelsToWorld(r, e.pixelUnprojectionMatrix),
        o = pixelsToWorld(a, e.pixelUnprojectionMatrix),
        i = n[0] / e.scale,
        s = o[0] / e.scale,
        l = e.unproject(r),
        u = e.unproject(a),
        c = {
      north: l[1],
      south: u[1],
      west: l[0],
      east: u[0]
    };
    t({
      type: SET_NATIVE_VIEWPORT,
      payload: {
        leftWorldScaled: i,
        rightWorldScaled: s,
        bounds: c
      }
    });
  };
};

function createThunkMiddleware(e) {
  return function (t) {
    var r = t.dispatch,
        a = t.getState;
    return function (t) {
      return function (n) {
        return "function" == typeof n ? n(r, a, e) : t(n);
      };
    };
  };
}

var thunk = createThunkMiddleware();

function cubicInOut(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}

thunk.withExtraArgument = createThunkMiddleware;
var TRANSITION_DURATION = 500,
    DEFAULT_TRANSITION = {
  transitionDuration: TRANSITION_DURATION,
  transitionInterpolator: new FlyToInterpolator(),
  transitionEasing: cubicInOut
},
    initialState = {
  viewport: {
    latitude: 0,
    longitude: 0,
    zoom: 3,
    bearing: 0,
    pitch: 0,
    width: 1e3,
    height: 800,
    bounds: {}
  },
  maxZoom: MAX_ZOOM_LEVEL,
  minZoom: MIN_ZOOM_LEVEL,
  prevZoom: 3,
  currentTransition: null
};

function ViewportReducer() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : initialState,
      t = arguments.length > 1 ? arguments[1] : void 0;

  switch (t.type) {
    case SET_VIEWPORT:
      return _objectSpread2({}, e, {
        viewport: t.payload,
        canZoomIn: t.payload.zoom < e.maxZoom,
        canZoomOut: t.payload.zoom > e.minZoom,
        prevZoom: e.viewport.zoom
      });

    case SET_BOUNDS:
      return _objectSpread2({}, e, {
        bounds: t.payload
      });

    case UPDATE_VIEWPORT:
      var r = _objectSpread2({}, e.viewport, {}, t.payload);

      return _objectSpread2({}, e, {
        viewport: r,
        prevZoom: r.zoom
      });

    case SET_ZOOM_INCREMENT:
      var a = e.viewport.zoom,
          n = Math.min(e.maxZoom, t.payload.zoom || a + t.payload.increment),
          o = _objectSpread2({}, e.viewport, {}, DEFAULT_TRANSITION, {
        zoom: n,
        latitude: null === t.payload.latitude ? e.viewport.latitude : t.payload.latitude,
        longitude: null === t.payload.longitude ? e.viewport.longitude : t.payload.longitude
      });

      return _objectSpread2({}, e, {
        viewport: o,
        canZoomIn: n < e.maxZoom,
        canZoomOut: n > e.minZoom,
        prevZoom: e.viewport.zoom,
        currentTransition: TRANSITION_TYPE.ZOOM
      });

    case SET_MOUSE_LAT_LONG:
      return _objectSpread2({}, e, {
        mouseLatLong: t.payload
      });

    case TRANSITION_END:
      return _objectSpread2({}, e, {
        currentTransition: null
      });

    case SET_NATIVE_VIEWPORT:
      return _objectSpread2({}, e, {}, t.payload);

    default:
      return e;
  }
}

var composeEnhancers = compose,
    composeWithDevTools;
process.env.REACT_APP_MAP_REDUX_REMOTE_DEBUG;

var store = createStore(function () {}, {}, composeEnhancers(applyMiddleware(thunk))),
    targetMapVessel = function targetMapVessel(e) {
  var t = store.getState().map.tracks.data.find(function (t) {
    return t.id === e.toString();
  });
  return store.dispatch(fitToBounds(t.geoBounds)), t.timelineBounds;
},
    fitToBounds$1 = function fitToBounds$1(e) {
  store.dispatch(fitToBounds(e)), setTimeout(function () {
    null !== store.getState().map.viewport.currentTransition && store.dispatch(transitionEnd());
  }, TRANSITION_DURATION + 1);
};

export { groupData as $, ACTIVITY_HIGHLIGHT_HUE as A, BRUSH_RENDERING_STYLE as B, CUSTOM_LAYERS_SUBTYPES as C, stubArray_1 as D, _arrayPush as E, _getPrototype as F, GL_TRANSPARENT as G, _baseGetAllKeys as H, _isPrototype as I, _getTag as J, _nodeUtil as K, _baseUnary as L, MAX_SPRITES_PER_LAYER as M, _copyArray as N, isBuffer_1 as O, POLYGON_LAYERS_AREA as P, _Stack as Q, _getAllKeys as R, STATIC_LAYERS_CARTO_TILES_ENDPOINT as S, TILES_URL_NEEDING_AUTHENTICATION as T, _Uint8Array as U, VESSELS_BASE_RADIUS as V, isArray_1 as W, _assignValue as X, startLoader as Y, getTilePromises as Z, getCleanVectorArrays as _, clearHighlightedVessels as a, completeLoader as a0, targetMapVessel as a1, SET_MODULE_CURSOR as a2, COMPLETE_LOADER as a3, START_LOADER as a4, SET_HIGHLIGHT_TEMPORAL_EXTENT as a5, SET_TEMPORAL_EXTENT as a6, INIT_MODULE as a7, CLEAR_HIGHLIGHT_CLICKED_VESSEL as a8, HIGHLIGHT_CLICKED_VESSEL as a9, fitToBounds$1 as aA, HIGHLIGHT_VESSELS as aa, UPDATE_LOADED_TILES as ab, RELEASE_HEATMAP_TILES as ac, UPDATE_HEATMAP_TILE as ad, ADD_REFERENCE_TILE as ae, REMOVE_HEATMAP_LAYER as af, UPDATE_HEATMAP_LAYER_STYLE as ag, ADD_HEATMAP_LAYER as ah, UPDATE_HEATMAP_LAYER_TEMPORAL_EXTENTS_LOADED_INDICES as ai, difference_1 as aj, INIT_HEATMAP_LAYERS as ak, RELEASE_MARKED_TILES_UIDS as al, MARK_TILES_UIDS_AS_LOADED as am, SET_CURRENTLY_SWAPPED_TILE_UIDS as an, SET_CURRENTLY_LOADED_TILES as ao, SET_CURRENTLY_VISIBLE_TILES as ap, ViewportReducer as aq, store as ar, initModule as as, setHighlightTemporalExtent as at, updateHeatmapLayers as au, updateLayerLoadTemporalExtents as av, transitionToZoom as aw, setCursor as ax, setTemporalExtent as ay, updateViewport as az, BRUSH_ZOOM_RENDERING_STYLE as b, clearHighlightedClickedVessel as c, VESSELS_HEATMAP_DIMMING_ALPHA as d, VESSEL_CLICK_TOLERANCE_PX as e, VESSELS_HEATMAP_BLUR_FACTOR as f, VESSELS_RADIAL_GRADIENT_STYLE_ZOOM_THRESHOLD as g, MIN_FRAME_LENGTH_MS as h, mapConvert as i, exportNativeViewport as j, TRACKS_LAYER_IN_FRONT_OF_GROUP as k, lngLatToWorld as l, setBounds as m, closePopup as n, STATIC_LAYERS_CARTO_ENDPOINT as o, _copyObject as p, queryHeatmapVessels as q, keys_1 as r, setViewport as s, transitionEnd as t, uniq_1 as u, vesselSatisfiesFilters as v, worldToPixels as w, keysIn_1 as x, _getSymbols as y, zoomIntoVesselCenter as z };